<script>
import { ref } from "vue";
import Multiselect from "@vueform/multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import Loader from "../components/loader";
import api from "@/axios";
import moment from "moment";
import Swal from "sweetalert2";
import { useMagicKeys, whenever } from "@vueuse/core";
import { Workbook } from "exceljs";
import { exportDataGrid } from "devextreme/excel_exporter";
import { saveAs } from "file-saver-es";
import DxButton from "devextreme-vue/button";
import DxToolbar, { DxItem } from "devextreme-vue/toolbar";
import DropZone from "@/components/widgets/dropZone.vue";
// import VueEasyLightbox from "vue-easy-lightbox";
import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel,
  DxGrouping,
  DxPager,
  DxFilterRow,
  DxRemoteOperations,
} from "devextreme-vue/data-grid";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  components: {
    Layout,
    PageHeader,
    Loader,
    Multiselect,
    DxToolbar,
    DxItem,
    DxButton,
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxColumnFixing,
    DxSelection,
    DxExport,
    DxStateStoring,
    DxGroupPanel,
    DxGrouping,
    DxPager,
    DxFilterRow,
    DxRemoteOperations,
    DropZone,
    // VueEasyLightbox
  },
  setup() {
    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0];
    };
    return { dropzoneFile, drop, v$: useVuelidate() };
  },
  data() {
    return {
      dtlistPesqNatureza: [],
      showErrosLotes: false,
      dtListLotes: [],
      listErroLote: [],
      transportadora: [],

      imgSmall: false,

      paramOrctoIsolado: false,
      paramOrctoConfParcFin: false,
      showModalCarga: false,
      submitCodCarga: false,
      loadingCargas: false,
      cargasData: null,

      paramSugereItens: false,
      showModalSugereItens: false,
      orctoItensSugeridos: false,
      submittedItensSugeridos: false,

      submittedPeriodo: false,
      valorTotalFinanc: 0,

      submitOrctoFinanc: false,
      showModalOrctoFinan: false,
      orctoFinanData: {},
      orctoFinansData: {},

      cotaFreteListData: {},

      loadingCotarFrete: false,
      showModalCotarFrete: false,
      showModalDesconto: false,
      messageValidacaoItem: "",
      margemBrutaOrcto: 0,

      showSelecionarEnder: false,
      showModalAuditoria: false,
      showModalTransp: false,
      showModalFrete: false,
      submitOrctoItem: false,

      loadingCliente: false,
      loadingCondPgto: false,
      loadingFormaPgto: false,
      loadingRepres: false,
      loadingPedTipo: false,
      loadingOrctoItem: false,
      loadingTransp: false,
      loadingFinanc: false,

      dtListPesqCli: [],
      dtListPesqCondPgto: [],
      dtListPesqFormaPgto: [],
      dtListPesqRepres: [],
      dtlistPesqPedTipo: [],
      dtlistPesqOrctoItem: [],
      dtListPesqTransp: [],
      dtListPesqFreteCota: [],
      dtListPesqConta: [],

      showModalCliente: false,
      showModalCondPgto: false,
      showModalDataOrcamento: false,
      showModalFormaPgto: false,
      showModalRepres: false,
      showModalPedTipo: false,
      showModalOrctoItem: false,
      showModalObs: false,
      showModalAcao: false,

      idRow: null,
      idProd: null,
      Prod: null,

      currentTab: "ItensOrcamento", // Aba inicial
      tabs: [
        { name: "ItensOrcamento", label: "Itens Orçamento" },
        { name: "SaldosConferencia", label: "Saldos de Conferência" },
        { name: "OSRelacionadas", label: "OS Relacionadas" },
      ],

      orctoData: {
        id: 0,
        status: "EL",
        formapgto: "10",
        condpgto: "10",
        cliente: "",
        //tipo: "20",
        tipo: 1, //Id de venda de mercadoria de 'natureza'
        dtemissao: new Date(),
      },
      clienteData: null,
      condPgtoData: {
        codigo: "10",
        descricao: "30 / 60 Dias",
      },
      formaPgtoData: {
        codigo: "10",
        descricao: "Boleto",
      },
      pedTipoData: {
        codigo: "20",
        descricao: "Venda Estabelecimento",
      },
      pessoaEnderData: {},
      represData: {},
      transpData: {},
      freteCotaData: {},
      orctoItemData: {},
      orctoItensData: null,
      countOrctoItens: 0,
      qtdTotalItens: 0,

      somaPedidosCli: 0,
      ultPedsData: null,
      errosValid: null,
      itensData: null,

      idData: 0,
      updating: true,
      title: "Orçamento",
      items: [
        {
          text: "Orçamentos",
          href: "/orcamentos/list",
        },
        {
          text: "Orçamento",
          active: true,
        },
      ],
      wmsos: [],
      wmsositens: [],

      showModalAddCampanha: false,
      dtListCampanhas: [],
      campanhaData: {},
      campanhaSelected: {},
      flagCampanhaParam: false,

      submittedAnexo: false,

      showModalIndicaPedido: false,
      dtListPedidos: [],
      flagAgregacaoPedido: false,
      naturezaData: {},
      orctoSalvo: false,
      showModalNatureza: false,

      showModalFinanceiroData: false,
      financeiroData: {
        condpgto: null,
        formapgto: null,
        banco: null,
        consutil: false,
      },

      showModalErro: false,
      errorMessage: "",

      showModalAssociaLotes: false,
      dtListAssociaLote: [],
      updatingReserva: false,
      showModalMsgUpdating: false,
      disableButton: false,
      empresaData: {}
    };
  },
  validations: {
    orctoItemData: {
      produto: {
        required: helpers.withMessage(
            "Campo produto obrigatório, favor preencher.",
            required
        ),
      },
      qtd: {
        required: helpers.withMessage(
            "Campo quantidade obrigatório, favor preencher.",
            required
        ),
      },
      vlrunitliq: {
        required: helpers.withMessage(
            "Campo valor unitário obrigatório, favor preencher.",
            required
        ),
      },
      vlrtotalliq: {
        required: helpers.withMessage(
            "Campo valor total obrigatório, favor preencher.",
            required
        ),
      },
    },
  },
  watch: {
    "orctoItemData.qtd": {
      handler() {
        this.calculaTotalItem();
      },
    },
    "orctoItemData.vlrunitliq": {
      handler() {
        this.calculaTotalItem();
      },
    },
  },

  computed: {
    dataGrid: function () {
      return this.$refs.dataGridRefKey.instance;
    },
  },

  mounted() {
    const keys = useMagicKeys();
    whenever(keys.alt_s, () => {
      if (
          this.paramOrctoConfParcFin === true
              ? this.orctoData.status === "EL"
              : this.orctoData.status === "EL" || this.orctoData.status === "CP"
      ) {
        this.salvarOrcamento();
      }
    });
    whenever(keys.alt_i, () => {
      this.imprimirOrcamento();
    });
    whenever(keys.alt_n, () => {
      if (
          this.paramOrctoConfParcFin === true
              ? this.orctoData.status === "EL"
              : this.orctoData.status === "EL" || this.orctoData.status === "CP"
      ) {
        this.novoProduto();
      }
    });

    this.$watch(
        "orctoItensSugeridos",
        function () {
          this.calculaTotalItemSug();
        },
        { deep: true }
    );

    console.log("mounted_orcamento_editar_0");
    let rota = this.$route.path;
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf("/");
    if (ultimaBarra) {
      this.idData = parseInt(rota.substring(ultimaBarra + 1));
    }
    console.log(`idData: ${this.idData}`);

    if (this.idData > 0) {
      this.carregarDados();
    } else {
      this.title = `Criando Novo Orçamento`;
      this.updating = false;
      let emprAtu = localStorage.getItem("empratu");
      this.orctoData.empresa = emprAtu;

      api.get(`${getBaseUrl()}api/orctodf`).then((res) => {
        console.log("res defaults");
        console.log(res);
        this.freteCotaData = res.data[0];
        if (this.freteCotaData && this.freteCotaData.id) {
          this.orctoData.segto = res.data[0].codigo;
          this.dtListPesqFreteCota = [
            {
              codigo: this.freteCotaData.codigo,
              nome: this.freteCotaData.nome,
            },
          ];
        }
      });
    }
  },

  methods: {
    reconsiderarSaldoItens(){
      console.log('reconsiderarSaldoItens')

      let itens = this.dataGrid.getSelectedRowsData()

      let validados = true
      itens.forEach((item) => {
        if(!item.desconsidsaldo){
          validados = false
        }
      })

      if(!validados){
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Todos os itens já estão sendo considerados!",
          showConfirmButton: false,
          timer: 2500,
        })
      } else {
        console.log('revalidar todos os itens')

        api.post(`${getBaseUrl()}api/reconsidsaldoorctoitem`, {
          iddata: this.orctoData.id
        }).then((res) => {
          console.log("then axioss reconsidsaldoorctoitem");
          console.log(res.data)
          // console.log(JSON.stringify(res.data))


          if(res.data.success) {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: res.data.message,
              showConfirmButton: false,
              timer: 2500,
            }).then(() => {
              this.carregarDados()
            })
          } else {
            Swal.fire({
              position: "top-end",
              icon: "danger",
              title: "Erro no processamento",
              showConfirmButton: false,
              timer: 2500,
            }).then(() => {
              this.carregarDados()
            })
          }
        })
      }
    },

    desconsiderarSaldoItens(){
      console.log('desconsiderarSaldoItens')

      console.log('itens: ' + JSON.stringify(this.orctoItensData))
      let itens = this.dataGrid.getSelectedRowsData()
      console.log('itens: ' + JSON.stringify(itens))

      api.post(`${getBaseUrl()}api/desconsidsaldoorctoitem`, {
        itens: itens
      }).then((res) => {
        console.log("then axioss desconsidsaldoorctoitem");
        console.log(res.data)
        // console.log(JSON.stringify(res.data))

        if(res.data.success) {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: res.data.message,
            showConfirmButton: false,
            timer: 2500,
          }).then(() => {
            this.carregarDados()
          })
        } else {
          Swal.fire({
            position: "top-end",
            icon: "danger",
            title: "Erro no processamento",
            showConfirmButton: false,
            timer: 2500,
          }).then(() => {
            this.carregarDados()
          })
        }
      })
    },

    gerarReservaSaldos(){
      console.log('gerarReservaSaldos')

      /*
      * Antes de realizar qualquer disparo, verificar se todos os lotes foram definidos
      */
      let validado = true
      this.dtListAssociaLote.forEach(item => {
        if(!item.lote || item.lote < 1) {
          validado = false
        }
      })

      if(!validado) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Todos os itens devem estar com lotes definidos!",
          showConfirmButton: false,
          timer: 3500,
        })
      } else {
        this.updatingReserva = true

        api.post(`${getBaseUrl()}api/reservasaldoloteswmsos`, {
          itens: this.dtListAssociaLote
        }).then((res) => {
          console.log("then axioss reservasaldolotes");
          console.log(res.data)
          // console.log(JSON.stringify(res.data))

          this.showModalAssociaLotes = false
          this.updatingReserva = false

          if(res.data.success) {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: res.data.message,
              showConfirmButton: false,
              timer: 2500,
            }).then(() => {
              this.carregarDados()
            })
          }
        })
      }
    },

    criaMovAjtFromOrcto() {
      console.log('criaMovAjtFromOrcto')
      this.updating = true;
      api.get(`${getBaseUrl()}api/criaorctomovajt`, {
        params: {
          idData: this.idData,
        }
      }).then((res) => {
        console.log('then axios criaorctomovajt')
        console.log(res.data)
        //console.log(JSON.stringify(res.data))

        this.showModalMsgUpdating = false

        if (res.data.success) {
          let movajt_id = res.data.movajt_id

          Swal.fire({
            position: "top-end",
            icon: "success",
            text: res.data.message ?? "Ajuste criado com sucesso!",
            showConfirmButton: false,
            timer: 2500,
          }).then(() => {
            let route = this.$router.resolve(`/movajuste/editar/${movajt_id}`);
            window.open(route.href, '_blank');
          });
        }else{
          Swal.fire({
            position: "top-end",
            icon: "error",
            text: res.data.error ?? "Criação de Ajuste Falhou!",
            showConfirmButton: false,
            timer: 3000,
          }).then(() => {
            this.carregarDados()
          });
        }
      })
          .then(() => {
            this.updating = false;
          })
    },

    removerNatureza(){
      if (this.orctoData.status !== 'EL'){
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          return
        });
      }

      console.log('delete natureza')
      this.orctoData.tipo = null
      this.salvarOrcamento()
    },

    editarNaturezas(){
      console.log('redirect to naturezas')

      let route = this.$router.resolve("/naturezas/list")
      window.open(route.href, '_blank')
    },

    escolheuNatureza(){
      console.log('escolheuNatureza')

      if(Array.isArray(this.dtlistPesqNatureza) && this.dtlistPesqNatureza.length > 0) {
        this.naturezaData = this.dtlistPesqNatureza.find((natureza) => {
          if (natureza.id === this.orctoData.tipo){
            console.log('natureza selected:')
            console.log(natureza)

            return natureza
          }
        })

        this.loadingPedTipo = false
        this.orctoData.tipo = this.naturezaData.id
        if  (this.orctoData.tipo !== null) {
          this.salvarOrcamento()
          //this.showModalNatureza = false
        }
      }
    },

    removerPedAssoc(){
      //console.log('removerPedAssoc')
      Swal.fire({
          position: 'center',
          icon: 'info',
          title: 'Desassociando Orçamento do Pedido!',
          showConfirmButton: false,
          timer: 2000
        }).then(() => {
          this.orctoData.agregped_id = null
          this.salvarOrcamento()
        })
    },

    escolheuPedido(){
      //console.log('escolheuPedido')

      this.salvarOrcamento()
      this.showModalIndicaPedido = false
    },

    pesqPedido(evt){
      console.log('pesqPedido')
      console.log('evt')
      console.log(evt)

      let query = evt
      console.log(query.length)
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/pesqped`, {
          params: {
            q: query,
          }
        }).then((res) => {
          console.log('then axios pesqPedido')
          console.log(res.data)

          this.dtListPedidos = res.data ?? []
        })
      }
    },

    pesqConta(evt){
      console.log('pesqFinConta')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/ccontapesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqConta = res.data
          this.dtListPesqConta.sort((a,b) => a.codigo - b.codigo);
        });
      }
    },

    escolheuConta() {
      console.log('selectedContaData', this.financeiroData.banco_id)
      this.loadingConta = true;
      this.loadingFinanc = true;
      console.log(this.financeiroData.banco_id);
      api.get(`${getBaseUrl()}api/cconta`, {
        params: { iddata: this.financeiroData.banco_id },
      }).then((res) => {
        console.log("then axios");
        // console.log(res.data);
        this.ContaData = res.data[0];

        this.loadingConta = false;
        this.loadingFinanc = false;
        this.financeiroData.banco_id = this.ContaData.id;
        this.financeiroData.banco = this.ContaData.banco;
      });
    },

    editarFinanceiro() {
      console.log('editarFinanceiro')

      this.showModalFinanceiroData = true;
    },

    confirmarFinanceiro() {
      console.log('confirmarFinanceiro')

      const financeiroData = this.financeiroData

      this.financeiroData.condpgto = financeiroData.condpgto
      this.financeiroData.formapgto = financeiroData.formapgto
      this.financeiroData.banco = financeiroData.banco
      this.financeiroData.consutil = financeiroData.consutil

      this.showModalFinanceiroData = false
    },

    removerCampanha(){
      console.log('remove campain')

      this.orctoData.codcampanha = null
      this.campanhaData = {}
      this.campanhaSelected = {}

      this.salvarOrcamento()
    },

    selectedFile(){
      this.dropzoneFile = document.querySelector(".dropzoneFile").files[0]

      let arquivoEmMegas = this.dropzoneFile.size / 1000000;
      if (arquivoEmMegas > 2) {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Panilha não pode passar 2 megas!",
          showConfirmButton: false,
          timer: 4000,
        }).then(() => {
          this.showModalImportarMovAjt = false;
        });
      }
    },

    validaImportacaoCampanha() {
      if (!this.campanhaData.descricao) {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Campo descrição obrigatório!",
          showConfirmButton: false,
          timer: 2500,
        }).then(() => {
          this.submittedAnexo = false;
        });
      } else {
        this.confirmarImportacaoCampanha();
      }
    },

    confirmarImportacaoCampanha() {
      this.submittedAnexo = true;
      if (this.dropzoneFile.name) {
        this.showModalAtuLogo = false;
        this.updating = true;

        let arquivo = document.querySelector(".dropzoneFile").files[0];
        console.log(arquivo);

        let arquivoEmMegas = arquivo.size / 1000;

        if (arquivoEmMegas > 300) {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Arquivo não pode ultrapassar 300 Kb!",
            showConfirmButton: false,
            timer: 4000,
          }).then(() => {
            this.submittedAnexo = false;
            this.dropzoneFile = "";
            this.carregarDados();
          });
        } else {
          let formData = new FormData();
          formData.append("iddata", this.idData);
          formData.append("campanha_descricao", this.campanhaData.descricao);
          formData.append("campanha_codigo", this.campanhaData.codigo);
          formData.append("filename", arquivo.name);
          formData.append("file", arquivo);

          api
            .post(`${getBaseUrl()}api/postcamp`, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((res) => {
              console.log("then axios postcamp");
              console.log(res.data);

              if (res.data.success) {
                Swal.fire({
                  position: "top-end",
                  icon: "success",
                  title: "Campanha inserida com sucesso!",
                  showConfirmButton: false,
                  timer: 2000,
                })
                  .then(() => {
                    this.campanhaData = {};
                    this.carregarDados();
                  })
                  .then(() => {
                    Swal.fire({
                      position: "top-end",
                      icon: "warning",
                      title: "Associe a campanha desejada ao orçamento!",
                      showConfirmButton: false,
                      timer: 3000,
                    });
                  });
              } else {
                Swal.fire({
                  position: "center",
                  icon: "error",
                  title: "Processamento falhou!",
                  text: res.data.error,
                  showConfirmButton: false,
                  timer: 5000,
                }).then(() => {
                  this.dropzoneFile = "";
                  this.showModalAddCampanha = false;
                  this.campanhaData = {};
                  this.carregarDados();
                });
              }
            })
            .catch((err) => {
              console.log("erro axios");
              // console.log(err)
              // console.log(err.response)
              // console.log(err.response.data.errors)
              let erros = err.response.data.errors;
              console.log(erros);
              console.log(typeof erros);
              let listaErros = [];
              Object.keys(erros).forEach((key) => {
                console.log(key, erros[key]);
                listaErros.push({
                  titulo: key,
                  mensagem: erros[key],
                });
              });
              this.showModalAddCampanha = false;
              this.errosValid = listaErros;
              this.updating = false;
              this.campanhaData = {};
              this.carregarDados();
            });
        }
      }
    },

    pesqCampanha(evt) {
      console.log("pesqCampanha");
      console.log("evt");
      console.log(evt);

      let query = evt;
      console.log(query.length);
      if (query.length > 1) {
        api
          .get(`${getBaseUrl()}api/pesqcamp`, {
            params: {
              q: query,
              orcamento_id: this.idData,
            },
          })
          .then((res) => {
            console.log("then axios pesqlotes");
            console.log(res.data);

            this.dtListCampanhas = res.data.campanhaList ?? [];
          });
      }
    },

    escolheuCampanha(evt) {
      console.log("escolheuCampanha");
      //console.log(`${typeof evt} - ${JSON.stringify(evt)}`)

      this.orctoData.codcampanha = evt;
      console.log(`codcampanha: ${this.orctoData.codcampanha}`);

      Swal.fire({
        position: "top-end",
        icon: "success",
        title: "Campanha adicionada!",
        showCancelButton: false,
        showConfirmButton: false,
        timer: 1500,
      }).then(() => {
        this.showModalAddCampanha = false;
        this.salvarOrcamento();
      });
    },

    pesqLotes(evt) {
      console.log("pesqLotes");
      console.log("evt");
      console.log(evt);

      let query = evt;
      console.log(query.length);
      if (query.length > 1) {
        api
          .get(`${getBaseUrl()}api/pesqlotes`, {
            params: {
              q: query,
              produto_id: this.orctoItemData["produto_id"],
              qtd: this.orctoItemData["qtd"],
            },
          })
          .then((res) => {
            console.log("then axios pesqlotes");
            console.log(res.data);

            this.dtListLotes = res.data;
            console.log("dtListLotes");
            console.log(this.dtListLotes);
          });
      }
    },

    escolheuLote(evt) {
      console.log("escolheuLote");
      console.log(evt);
    },

    formataLotes(orctoItemData) {
      console.log("formataLotes");

      const strToArr = orctoItemData.lotes.split(",").map((s) => s.trim());

      let orctoitem = this.orctoItensData.forEach((value) => {
        return value.produto_id === orctoItemData.produt_id;
      });

      if (orctoitem) {
        orctoitem.lotes = strToArr;
      }
    },

    calculaTotalItemSug() {
      console.log("calculaTotalItemSug");
      this.orctoItensSugeridos.forEach((value) => {
        value.vlrtotalliq = value.qtd * value.vlrunitliq;
      });
    },

    deletarItemSug(indexVol) {
      console.log("deletarItemSug");
      console.log(indexVol);
      this.orctoItensSugeridos.splice(indexVol, 1);
    },

    abrirModalCarga() {
      this.showModalCarga = true;
      this.loadingCargas = true;
      if (
        this.paramOrctoConfParcFin === true
          ? this.orctoData.status === "EL"
          : this.orctoData.status === "EL" || this.orctoData.status === "CP"
      ) {
        api
          .get(`${getBaseUrl()}api/orctocargas`, {
            params: { iddata: this.idData },
          })
          .then((res) => {
            console.log("resData orctoCargas");
            console.log(res.data[0]);
            this.cargasData = res.data[0];
            this.loadingCargas = false;
          });
      }
    },

    selectTab(tab) {
      this.currentTab = tab;
    },

    confCodCarga() {
      console.log("confCodCarga");
      this.showModalCarga = false;
      this.updating = true;

      this.salvarOrcamento();
    },

    fecharOrcamento() {
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Fechar orçamento",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        showConfirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then((result) => {
        if (result.value) {
          api
            .get(`${getBaseUrl()}api/quitarorcto`, {
              params: {
                iddata: this.idData,
              },
            })
            .then((res) => {
              console.log("then fecharOrcamento");
              console.log(res.data);

              let flag = res.data.success ?? false;

              if (flag) {
                Swal.fire({
                  position: "top-end",
                  icon: "success",
                  text: res.data.message,
                  showCancelButton: false,
                  showConfirmButton: false,
                  timer: 2500,
                }).then(() => {
                  this.atualizaPagina();
                });
              } else {
                Swal.fire({
                  position: "top-end",
                  icon: "error",
                  text: res.data.error,
                  showCancelButton: false,
                  showConfirmButton: false,
                  timer: 2500,
                }).then(() => {
                  this.atualizaPagina();
                });
              }
            })
            .catch((e) => {
              console.log("error");
              console.log(e);
            });
        }
      });
    },

    deletarOrctoSugestao(data) {
      console.log("deletarOrctoSugestao");
      this.orctoItensSugeridos.splice(
        this.orctoItensSugeridos.indexOf(data),
        1
      );
    },

    confSugestao() {
      console.log("confSugestao");
      this.showModalSugereItens = false;
      this.updating = true;
      let itensSugFinal = [];
      this.orctoItensSugeridos.forEach((value) => {
        if (value.qtd > 0) {
          itensSugFinal.push(value);
        }
        value["orcamento_id"] = this.idData;
      });
      // console.log('itensSugFinal')
      // console.log(itensSugFinal)
      api
        .post(`${getBaseUrl()}api/orctoitens`, {
          orctoItensData: itensSugFinal,
        })
        .then((res) => {
          console.log("then axios");
          console.log(res);
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 2000,
          });
          this.carregarDados();
        });
    },

    redirecionaPedido(idOs) {
      console.log("redirecting to pedido");

      const url = this.$router.resolve({
        path: `/wmsos/saidaeditarnova/${idOs}`,
      }).href;
      window.open(url, "_blank");
    },

    atualizaPagina() {
      window.location.reload();
    },

    excluirFinanc() {
      console.log("excluirFinanc");
      this.showModalOrctoFinan = false;

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then((result) => {
        if (result.value) {
          this.updating = true;
          api
            .delete(`${getBaseUrl()}api/orctofinanc`, {
              params: {
                iddata: this.orctoFinanData.id,
              },
            })
            .then((res) => {
              console.log("then axios delete");
              console.log(res.data);
              this.carregarDados();
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Informações excluídas com sucesso!",
                showConfirmButton: false,
                timer: 1500,
              });
            });
        }
      });
    },

    alteraPagamento(dataSel) {
      console.log("alteraPagamento");
      this.orctoFinanData = dataSel;
      this.dtListPesqFormaPgto = [
        {
          codigo: dataSel.formapgto,
          descricao: dataSel.formapgtodesc,
        },
      ];
      this.showModalOrctoFinan = true;
    },

    novoPagamento() {
      console.log("exibirPagamentos");
      this.orctoFinanData = {};
      this.submitOrctoFinanc = false;
      this.showModalOrctoFinan = true;
    },

    escolherFrete(cotafrt_id, transpcnpj, valorFrete) {
      console.log("escolherFrete");
      console.log(valorFrete);
      this.orctoData.valorfrt = valorFrete;
      this.orctoData.cotafrt_id = cotafrt_id;
      this.orctoData.transp = transpcnpj;
      this.showModalCotarFrete = false;
      console.log('oct')
      console.log(this.orctoData)
      this.salvarOrcamento();

      Swal.fire({
        position: "top-end",
        icon: "success",
        title: "Frente selecionado com sucesso!",
        showConfirmButton: false,
        timer: 1500,
      }).then(() => {
        this.atualizaPagina();
      });
    },

    cotarFrete() {
      console.log("cotarFrete");
      this.showModalCotarFrete = true;
      this.loadingCotarFrete = true;

      api
        .get(`${getBaseUrl()}api/cotarfreteocto`, {
          params: { iddata: this.idData },
        })
        .then((res) => {
          console.log("res cotarFrete");
          console.log(res.data[0]);

          if (!res.data["SDT_WSRetorno"]) {
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: res.data[0],
              showConfirmButton: false,
              timer: 5000,
            }).then(() => {
              // this.atualizaPagina()
            });
          } else {
            console.log(res.data["SDT_WSRetorno"]["Resultados"]);
            // console.log(res.data[0]['SDT_WSRetorno'])
            this.cotaFreteListData = res.data["SDT_WSRetorno"]["Resultados"];

            // ordenar array pela WSOut_Frete_Val
            this.cotaFreteListData = this.cotaFreteListData
              .slice()
              .sort(function (a, b) {
                return a.WSOut_Frete_Val - b.WSOut_Frete_Val;
              });

            let menorValor = 999999;
            let menorPrazo = 999999;
            this.cotaFreteListData.forEach((value) => {
              if (value.WSOut_Frete_Val < menorValor) {
                menorValor = value.WSOut_Frete_Val;
              }
              if (value.WSOut_Prazo_Dias < menorPrazo) {
                menorPrazo = value.WSOut_Prazo_Dias;
              }

              value.WSOut_Frete_Val = parseFloat(value.WSOut_Frete_Val);
            });

            this.cotaFreteListData.forEach((value) => {
              if (value.WSOut_Frete_Val === menorValor) {
                value["menorvalor"] = true;
              }
              if (value.WSOut_Prazo_Dias === menorPrazo) {
                value["menorprazo"] = true;
              }
            });

            this.loadingCotarFrete = false;
          }
        });
    },

    auditoria() {
      console.log("auditoria");
      this.showModalAuditoria = true;
    },

    focusProdOrctoItem() {
      this.$refs.focusThis.focus();
    },

    imprimirOrcamento() {
      this.updating = true;
      api
        .get(`${getBaseUrl()}api/orctopdf`, {
          responseType: "blob",
          params: { iddata: this.idData },
        })
        .then((res) => {
          var fileURL = window.URL.createObjectURL(new Blob([res.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute(
            "download",
            "Orcamento " + this.idData + ".pdf"
          );
          document.body.appendChild(fileLink);
          fileLink.click();
          this.updating = false;
        });
    },

    copiarOrcamento() {
      console.log("copiarOrcamento");
      this.updating = true;
      api
        .post(`${getBaseUrl()}api/orctocopy`, {
          iddata: this.idData,
        })
        .then((res) => {
          console.log("then axios copiar");
          console.log(res.data[0].id);
          //this.orctoData = res.data

          this.idData = res.data[0].id;
          this.$router.replace({ path: `/orcamento/editar/${this.idData}` });
          this.carregarDados();

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Orçamento copiado com sucesso!",
            showConfirmButton: false,
            timer: 1500,
          });
        });
    },

    redirecionarOrcamentoWMS() {
      console.log("redirecionarOrcamentoWMS");
      this.updating = true;
      api.post(`${getBaseUrl()}api/recionaorcamentowmseconopro`, {
        iddata: this.idData,
      }).then((res) => {
        console.log("then axios redirecionarOrcamentoWMS");
        console.log(res.data);
        this.updating = false;
        if (res.data.success) {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title:
              res.data.message || "Redirecionamento realizado com sucesso!",
            showConfirmButton: false,
            timer: 2500,
          });
        } else {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: res.data.error || "Erro ao realizar redirecionamento!",
            showConfirmButton: false,
            timer: 4000,
          });
        }
      }).catch((err) => {
        console.log("erro axios redirecionarOrcamentoWMS");
        console.log(err);
        this.updating = false;
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "Erro na comunicação com o servidor!",
          showConfirmButton: false,
          timer: 4000,
        });
      });
    },

    copiarOrcamento02() {
      console.log("copiarOrcamento02");
      this.updating = true;
      api
        .post(`${getBaseUrl()}api/orctocopy02`, {
          iddata: this.idData,
        })
        .then((res) => {
          console.log("then axios copiar");
          console.log(res.data[0].id);
          //this.orctoData = res.data

          this.idData = res.data[0].id;
          this.$router.replace({ path: `/orcamento/editar/${this.idData}` });
          this.carregarDados();

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Orçamento copiado com sucesso!",
            showConfirmButton: false,
            timer: 1500,
          });
        });
    },

    deletarOrctoItem(iditem) {
      console.log("deletarOrctoItem");
      console.log(iditem);

      if (
        this.paramOrctoConfParcFin === true
          ? this.orctoData.status === "EL"
          : this.orctoData.status === "EL" || this.orctoData.status === "CP"
      ) {
        Swal.fire({
          position: "center",
          icon: "question",
          title: "Exclusão de Registro",
          text: "Esta operação é irreversível, tem certeza que deseja continuar?",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,
        }).then((result) => {
          if (result.value) {
            this.updating = true;
            api
              .delete(`${getBaseUrl()}api/orctoitem`, {
                params: {
                  iddata: iditem,
                },
              })
              .then((res) => {
                console.log("then axios delete");
                console.log(res.data);
                this.carregarDados();
                Swal.fire({
                  position: "top-end",
                  icon: "success",
                  title: "Informações excluídas com sucesso!",
                  showConfirmButton: false,
                  timer: 1500,
                });
              });
          }
        });
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500,
        });
      }

      this.showModalAcao = false;
    },

    calculaTotalItem() {
      console.log("calculaTotalItem");

      // let desc = this.orctoItemData.desconto
      let quant = this.orctoItemData.qtd;
      let vlrUnit = this.orctoItemData.vlrunitliq;
      let vlrUnitTab = this.orctoItemData.vlrunitbrt;
      let percDesc = 0;

      if (quant > 0 && vlrUnit > 0) {
        console.log("valorTotalItem");
        console.log(valorTotalItem);

        if (vlrUnit !== vlrUnitTab) {
          percDesc = (1 - vlrUnit / vlrUnitTab) * 100;
        }

        let valorTotalItem = quant * vlrUnit;

        // this.orctoItemData.desconto = percDesc
        this.orctoItemData.vlrtotalbrt = vlrUnitTab * quant;
        this.orctoItemData.vlrtotalliq = valorTotalItem;

        if (percDesc > 1000) {
          this.messageValidacaoItem =
            "Margem máxima de desconto atingida (30%), favor corrigir antes de confirmar";
        } else {
          this.messageValidacaoItem = "";
        }

        this.orctoItemData.pesobrttot = this.orctoItemData.pesobrtun * quant;
        this.orctoItemData.pesoliqtot = this.orctoItemData.pesoliqun * quant;
        this.orctoItemData.cubtot = this.orctoItemData.cubunt * quant;
      }
    },

    confOrctoItem() {
      console.log("confOrctoItem: " + this.idData);
      this.v$.$touch();
      this.submitOrctoItem = true;

      if (this.v$.$invalid) {
        return;
      } else {
        console.log("formSubmit_validado");
        this.loadingOrctoItem = true;

        console.log(`item: ${this.orctoItemData}`);
        api.post(`${getBaseUrl()}api/orctoitem`, {
            orctoItemData: this.orctoItemData,
          }).then((res) => {
            console.log("then axios");
            console.log(res);
            this.produtoData = res.data[0];
            this.updating = false;

            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações salvas com sucesso!",
              showConfirmButton: false,
              timer: 2000,
            });
            this.loadingOrctoItem = false;
            this.showModalOrctoItem = false;
            this.carregarDados();
            // this.atualizaPagina()
          }).catch((err) => {
            console.log("erro axios");
            // console.log(err)
            console.log(err.response);
            console.log(err.response.data.errors);
            let erros = err.response.data.errors;
            console.log(erros);
            console.log(typeof erros);
            let listaErros = [];
            Object.keys(erros).forEach((key) => {
              console.log(key, erros[key]);
              listaErros.push({
                titulo: key,
                mensagem: erros[key],
              });
            });
            this.errosValid = listaErros;
            this.updating = false;
            this.activeTab = 0;
            // this.atualizaPagina()
          });
      }
    },

    confOrctoFinanc() {
      console.log("confOrctoFinanc: " + this.idData);
      this.v$.$touch();
      this.submitOrctoFinanc = true;
      if (!this.orctoFinanData.valor && !this.orctoFinanData.formapgto) {
        return;
      } else {
        console.log("submitOrctoFinanc_validado");
        this.orctoFinanData.orcamento_id = this.idData;
        this.updating = true;
        api
          .post(`${getBaseUrl()}api/orctofinanc`, {
            orctoFinancData: this.orctoFinanData,
          })
          .then((res) => {
            console.log("then axios");
            console.log(res);
            // this.produtoData = res.data[0]
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações salvas com sucesso!",
              showConfirmButton: false,
              timer: 1500,
            });
            this.updating = false;
            this.showModalOrctoFinan = false;
            this.carregarDados();
          })
          .catch((err) => {
            console.log("erro axios");
            // console.log(err)
            console.log(err.response);
            console.log(err.response.data.errors);
            let erros = err.response.data.errors;
            console.log(erros);
            console.log(typeof erros);
            let listaErros = [];
            Object.keys(erros).forEach((key) => {
              console.log(key, erros[key]);
              listaErros.push({
                titulo: key,
                mensagem: erros[key],
              });
            });
            this.errosValid = listaErros;
            this.updating = false;
          });
      }
    },

    novoProduto() {
      console.log("novoProduto: " + this.idData);

      if (this.idData === 0) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor salvar o orçamento antes de adicionar item",
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        this.orctoItemData = {};
        this.showModalOrctoItem = true;
      }
    },

    detalhesProduto(idProd) {
      console.log("detalhesProduto: " + idProd);

      // this.$router.push(`/produto/editar/${idProd}`);

      let route = this.$router.resolve({ path: `/produto/editar/${idProd}` });
      window.open(route.href);

      this.showModalAcao = false;
    },

    editarProduto(idProd) {
      console.log("editarProduto: " + idProd);

      if (
        this.paramOrctoConfParcFin === true
          ? this.orctoData.status === "EL"
          : this.orctoData.status === "EL" || this.orctoData.status === "CP"
      ) {
        this.showModalOrctoItem = true;
        this.loadingOrctoItem = true;

        api.get(`${getBaseUrl()}api/orctoitem`, {
            params: { iddata: idProd },
          }).then((res) => {
            console.log("then axios editarProduto");
            console.log(res.data[0]);

            this.orctoItemData = res.data[0];

            if (this.orctoItemData.imgs) {
              let imgTrat = this.orctoItemData.imgs.split(",");
              this.orctoItemData.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`;
            }

            this.loadingOrctoItem = false;

            this.dtListLotes = this.orctoItemData["lote"] ?? [];

            console.log("item");
            console.log(this.orctoItemData);
          });
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500,
        });
      }

      this.showModalAcao = false;
    },

    confirmarOrcamento() {
      console.log("confirmarOrcamento: " + this.idData);
      //console.log(this.orctoData.condpgto);
      //console.log(this.condPgtoData);
      //console.log(this.orctoData.formapgto);
      //console.log(this.formaPgtoData);

      this.disableButton = false

      Swal.fire({
        position: "center",
        icon: "info",
        title: "Validando os dados para confirmação do orçamento!",
        showConfirmButton: false,
        timer: 1500,
      });

      if (
          this.orctoFinansData.length > 0 &&
          this.orctoData.valorliq !== this.valorTotalFinanc
      ) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Valor financeiro deve ser igual a valor líquido de orçamento, favor corrigir.",
          showConfirmButton: false,
          timer: 2500,
        });
        this.showModalMsgUpdating = false
        this.disableButton = false
      } else {
        if (!this.orctoItensData || this.orctoItensData.length <= 0) {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: "Favor adicionar produto ao orçamento antes de confirmar",
            showConfirmButton: false,
            timer: 1500,
          });
          this.showModalMsgUpdating = false
          this.disableButton = false
        } else {
          this.updating = true
              api
                .get(`${getBaseUrl()}api/validaorctoitems`, {
                  params: {
                    iddata: this.idData,
                  },
                }).then((res) => {
                  //console.log("then validaorctoitems");
                  //console.log(JSON.stringify(res.data));
                  this.showModalMsgUpdating = false
                  let validacaoItens = res.data;
                  this.updating = false

                  if (!validacaoItens.empresaParam) {
                    console.log("skip validação saldo");

                  this.dispararConfirmOrcamento();
                } else {
                  if (validacaoItens.contemWmsos !== undefined && validacaoItens.contemWmsos !== null && validacaoItens.contemWmsos) {
                    Swal.fire({
                      position: "center",
                      icon: "warning",
                      title: "Atenção",
                      text: "Ordens de saída pendentes!",
                      showConfirmButton: true,
                      showCancelButton: true,
                      confirmButtonText: "Redirecionar",
                      cancelButtonText: "Cancelar"
                    }).then((confirmed) => {
                      if (confirmed.isConfirmed) {
                        let wmsos_id = validacaoItens.wmsosExistente
                        if(wmsos_id !== null && wmsos_id !== undefined && wmsos_id < 0) {
                          Swal.fire({
                            position: "center",
                            icon: "error",
                            title: "Error",
                            text: "Redirecionamento falhou!",
                            showConfirmButton: false,
                            showCancelButton: false,
                            timer: 2500,
                          }).then(() => {
                            this.carregarDados()
                            this.disableButton = false
                            this.showModalMsgUpdating = false
                            return
                          });
                        }

                        /***Redirecionando em caso de sucesso*/
                        this.$router.push("/wmsos/saidaeditarnova/" + wmsos_id)
                      } else {
                        this.disableButton = false
                      }
                    });
                  }else{
                    if (validacaoItens.flagSaldoLoteIndisponivel) {
                      Swal.fire({
                        position: "center",
                        icon: "error",
                        title: "Lote indisponível",
                        text: "O lote indicado não possui mais saldo disponível, favor editar o item e confirmar novamente",
                        showConfirmButton: true,
                        timer: 10000,
                      }).then(() => {
                        console.log("lotes indisponiveis");
                        this.showErrosLotes = true;
                        this.listErroLote = res.data.lotesIndisponiveis;
                        this.disableButton = false
                        this.showModalMsgUpdating = false
                      });
                    } else {
                      if (!validacaoItens.flagNegativo) {
                        this.dispararConfirmOrcamento();
                      } else {
                        if (validacaoItens.flagNegativo && validacaoItens.flagConfLoteWmsos) {
                          Swal.fire({
                            position: "center",
                            icon: "error",
                            title: "Gerar Ajuste de entrada?",
                            text: "Sua empresa possui parâmetro de conferências lotes ativada! Saldo de entrada é obrigatório!",
                            showConfirmButton: true,
                            confirmButtonText: "Criar",
                            showCancelButton: true,
                            cancelButtonText: "Não",
                          }).then(check => {
                            if(check.isConfirmed) {
                              console.log('criar movajt')
                              this.criaMovAjtFromOrcto()
                              this.carregarDados()
                              this.showModalMsgUpdating = false
                            } else {
                              this.disableButton = false
                            }
                          })
                        }else{
                          Swal.fire({
                            position: "center",
                            icon: "error",
                            title: "Itens sem estoque disponível!",
                            text: "Deseja realizar uma entrada?",
                            showConfirmButton: true,
                            confirmButtonText: "Sim",
                            showCancelButton: true,
                            cancelButtonText: "Não"
                          }).then((check) => {
                            if (check.isConfirmed) {
                              this.showModalMsgUpdating = true
                              this.criaMovAjtFromOrcto()
                              this.carregarDados()
                            } else {

                              this.listErroLote = []
                              this.showModalMsgUpdating = false

                              /*
                              * Validando lotes dos itens
                              */
                              console.log('validando lotes')
                              this.orctoItensData.forEach((item) => {
                                if(item.deflote && (item.lote === null || item.lote === "")){
                                  this.listErroLote.push(
                                      {'sequenc': item.sequenc, 'codprod': item.produto, 'descprod': item.descprod}
                                  )
                                }
                              })

                              if(this.listErroLote.length > 0){
                                console.log('produto sem lote definido!')

                                Swal.fire({
                                  position: "top-end",
                                  icon: "warning",
                                  title: "Produtos sem lote definido!",
                                  showConfirmButton: false,
                                  timer: 2500,
                                })

                                this.showModalMsgUpdating = false
                                this.showErrosLotes = true
                                this.disableButton = false
                                return
                              }

                              Swal.fire({
                                position: "center",
                                icon: "error",
                                title: "Confirmação de orçamento cancelada!",
                                text: "Valide o estoque antes de dar continuidade aos fluxos de saída!",
                                confirmButton: false,
                                timer: 5000,
                              });
                              this.disableButton = false
                            }
                          });
                        }
                      }
                    }
                  }
                }
              })
              .catch(error => {
                console.error("Erro na comunicação da API:", error);
                this.updating = false
                this.disableButton = false
              });
        }
      }
    },

    dispararConfirmOrcamento() {
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Confirmação de Orçamento",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then((result) => {
        if (result.value) {
          this.updating = true;
          this.showModalMsgUpdating = true

          api.post(`${getBaseUrl()}api/orctoconfnovo`, {
              //focusnfeorctoconf | orctoconf
              iddata: this.idData,
            }).then((res) => {
              this.showModalMsgUpdating = false
              console.log("then axios confirmarOrcamento");
              console.log(res.data);
              //console.log(JSON.stringify(res.data));
              this.disableButton = false

              /*
              * Validando nova associação de lote
               */
              if (!res.data.success && res.data?.tipoErro === 'lote') {
                console.log('error associação de lote')

                Swal.fire({
                  position: "top-end",
                  icon: "error",
                  title: res.data.error,
                  showConfirmButton: false,
                  timer: 4000,
                }).then(() => {
                  this.dtListAssociaLote = res.data.itensError
                  console.log(JSON.stringify(this.dtListAssociaLote))

                  if(this.dtListAssociaLote.length > 1) {
                    this.showModalAssociaLotes = true
                  }
                });
              } else {
                let idRedirecionamento = res.data.id;

                if (this.paramOrctoIsolado) {
                  Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Orçamento confirmado com sucesso",
                    text: "Encaminhando para lista de orçamentos!",
                    showConfirmButton: false,
                    timer: 4000,
                  }).then(() => {
                    this.orctoData.status = "CO";
                    this.$router.push(`/orcamentos/list`);
                  });
                } else {
                  if (res.data.success === true) {
                    if (res.data.processo === "wmsos") {
                      Swal.fire({
                        position: "top-end",
                        icon: "success",
                        title: "Orçamento confirmado com sucesso",
                        text: "Encaminhando para conferência de saída!",
                        showConfirmButton: false,
                        timer: 4000,
                      }).then(() => {
                        console.log("redirecting to wmsos...");

                        //this.$router.replace({ path: `/wmsos/saidaeditarnova/${idRedirecionamento}`});
                        this.$router.push({ path: `/wmsos/saidaeditarnova/${idRedirecionamento}`});
                      });
                    } else if (res.data.processo === "pedido") {
                      Swal.fire({
                        position: "top-end",
                        icon: "success",
                        title: "Orçamento confirmado com sucesso",
                        text: "Encaminhando para o novo pedido que foi criado!",
                        showConfirmButton: false,
                        timer: 4000,
                      }).then(() => {
                        console.log("redirecting to pedido...");
                        this.$router.push(
                            `/pedido/detalhe/${idRedirecionamento}`
                        );
                      });
                    }
                  } else {
                    Swal.fire({
                      position: "top-end",
                      icon: "error",
                      title: res.data.msg ?? "Erro ao confirmar o orçamento!",
                      text: res.data[1],
                      showConfirmButton: false,
                      timer: 2500,
                    }).then(() => {
                      this.updating = false;
                      this.errorMessage = res.data.errorValidacaoProduto
                      this.showModalErro = true
                    });
                  }
                }
              }
            });
          }
      });
    },

    reverterCancelarOrcto() {
      if (this.idData > 0) {
        this.updating = true;

        api
            .post(`${getBaseUrl()}api/orctorevert`, {
              iddata: this.idData,
            })
            .then((res) => {
              console.log("then axios");
              console.log(res.data);
              this.orctoData = res.data[0];
              this.updating = false;

              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Orçamento revertido com sucesso!",
                showConfirmButton: false,
                timer: 1500,
              });
            });
      }
    },

    cancelarOrcamento() {
      console.log("cancelarOrcamento: " + this.idData);
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Cancelamento de Orçamento",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then((result) => {
        if (result.value) {
          if (this.idData > 0) {
            this.updating = true;
            api
                .post(`${getBaseUrl()}api/orctocanc`, {
                  iddata: this.idData,
                })
                .then((res) => {
                  console.log("then axios");
                  console.log(res);
                  this.orctoData = res.data[0];
                  this.updating = false;
                  Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Orçamento cancelado com sucesso!",
                    showConfirmButton: false,
                    timer: 1500,
                  });
                });
          } else {
            this.$router.go(-1);
          }
        }
      });
    },

    /*nomeStatus(stsIn) {
      let result = 'Não Definido'
      switch (stsIn) {
        case 'EL':
          result = 'Elabotação'
          break
        case 'FA':
          result = 'Faturado'
          break
        case 'CA':
          result = 'Cancelado'
          break
      }
      return result
    },*/

    alteraObs() {
      console.log("alteraObs");
      if (
          this.paramOrctoConfParcFin === true
              ? this.orctoData.status === "EL"
              : this.orctoData.status === "EL" || this.orctoData.status === "CP"
      ) {
        this.showModalObs = true;
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    alteraTransp() {
      console.log("alteraTransp");
      if (
          this.paramOrctoConfParcFin === true
              ? this.orctoData.status === "EL"
              : this.orctoData.status === "EL" || this.orctoData.status === "CP"
      ) {
        this.showModalTransp = true;
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    alteraFrete() {
      console.log("alteraFrete");
      if (
          this.paramOrctoConfParcFin === true
              ? this.orctoData.status === "EL"
              : this.orctoData.status === "EL" || this.orctoData.status === "CP"
      ) {
        this.showModalFrete = true;
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    alteraDesconto() {
      console.log("alteraDesconto");
      if (
          this.paramOrctoConfParcFin === true
              ? this.orctoData.status === "EL"
              : this.orctoData.status === "EL" || this.orctoData.status === "CP"
      ) {
        this.showModalDesconto = true;
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    carregarDados() {
      api
          .get(`${getBaseUrl()}api/orcamento`, {
            params: { iddata: this.idData },
          })
          .then((res) => {
            console.log("then axios carregarDados");
            console.log(res.data);

            this.orctoData = res.data[0];
            this.clienteData = res.data[1];
            this.pedTipoData = res.data[2];
            this.formaPgtoData = res.data[3];
            this.condPgtoData = res.data[4];
            this.orctoItensData = res.data[5];
            // console.log(`orctoItensData: ${JSON.stringify(this.orctoItensData)}`)
            this.represData = res.data[6];
            this.pessoaEnderData = res.data[7];
            this.freteCotaData = res.data[8];
            this.orctoFinansData = res.data[9];
            this.wmsos = res.data[10];
            this.wmsositens = res.data[11];

            if (res.data[13]) {
              this.campanhaSelected = res.data[13];
            }

            this.flagCampanhaParam = this.orctoData.flagCampanha;

            if(res.data[14]){
              this.flagAgregacaoPedido = res.data[14]
            }

            if (res.data[15]){
              this.naturezaData = res.data[15]
            }

            if (res.data[16]){
              this.transportadora = res.data[16]
            }

            this.empresaData = res.data[17]
            console.log(`empresaData: ${JSON.stringify(this.empresaData)}`)

            let totalFinanc = 0;
            this.orctoFinansData.forEach((value) => {
              totalFinanc += value.valor;
            });
            this.valorTotalFinanc = totalFinanc;

            if (this.freteCotaData && this.freteCotaData.id) {
              this.dtListPesqFreteCota = [
                {
                  codigo: this.freteCotaData.codigo,
                  nome: this.freteCotaData.nome,
                },
              ];
            }

            if (this.condPgtoData && this.condPgtoData.id){
              this.dtListPesqCondPgto = [
                {
                  id: this.condPgtoData.id,
                  codigo: this.condPgtoData.codigo,
                  descricao: this.condPgtoData.descricao,
                }
              ];

              this.financeiroData.condpgto = this.condPgtoData.codigo;
            }

            if (this.formaPgtoData && this.formaPgtoData.id){
              this.dtListPesqCondPgto = [
                {
                  id: this.formaPgtoData.id,
                  codigo: this.formaPgtoData.codigo,
                  descricao: this.formaPgtoData.descricao,
                }
              ]

              this.financeiroData.formapgto = this.formaPgtoData.codigo;
            }

            this.countOrctoItens = this.orctoItensData?.length ?? 0;

            let valorTotal = 0;
            let qtdTotalItens = 0;
            let margemTotal = 0;

            if (this.countOrctoItens > 0) {
              this.orctoItensData.forEach((value) => {
                if (value.imgs) {
                  let imgTrat = value.imgs.split(",");
                  value.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`;
                }

                // console.log(value.vlrtotalliq);
                valorTotal += parseFloat(value.vlrtotalliq) || 0;
                qtdTotalItens += parseFloat(value.qtd) || 0;

                if (value.margem) {
                  margemTotal += parseFloat(value.margem) || 0;
                }
              });
            }

            res.data[12].forEach((valueParam) => {
              if (valueParam) {

                //console.log("valueParam");
                //console.log(valueParam);

                if (valueParam.valor === "ORCTO_ISOL") {
                  this.paramOrctoIsolado = true;
                } else if (valueParam.valor === "CONF_PARC_FIN") {
                  this.paramOrctoConfParcFin = true;
                } else if (valueParam.valor === "SUGERE_ITENS_ORCTO") {
                  this.paramSugereItens = true;
                }
              }
            });

            this.valorTotalItens = valorTotal;
            this.qtdTotalItens = qtdTotalItens;
            this.margemBrutaOrcto = margemTotal;

            this.idData = this.orctoData.id;
            this.title = `${this.orctoData.empresa} - Editar Orçamento (${this.orctoData.id}) ${this.clienteData.nome}`;
            this.updating = false;

            if (
                this.paramSugereItens === true &&
                this.paramSugereItens === true &&
                (!this.orctoItensData || this.orctoItensData.length === 0)
            ) {
              //console.log("this.paramSugereItens");
              //console.log(this.paramSugereItens);

              api.get(`${getBaseUrl()}api/cliultitens`, {
                params: { coddata: this.orctoData.cliente },
              })
                  .then((resitens) => {
                    console.log("then axios_cliultitens");
                    console.log(resitens.data);

                    this.showModalSugereItens = true;
                    this.orctoItensSugeridos = resitens.data[0];
                    console.log(resitens.data[0][0]);
                    setTimeout(() => {
                      document
                          .getElementById("sug_qtd" + resitens.data[0][0].produto_id)
                          .focus();
                    }, 1500);
                  });
            }
          });
    },

    selecionaCli() {
      console.log("selecionaCli");
      if (
          this.paramOrctoConfParcFin === true
              ? this.orctoData.status === "EL"
              : this.orctoData.status === "EL" || this.orctoData.status === "CP"
      ) {
        this.showModalCliente = true;
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    editaDataOrcamento() {
      console.log("editaDataOrcamento");
      if (
          this.paramOrctoConfParcFin === true
              ? this.orctoData.status === "EL"
              : this.orctoData.status === "EL" || this.orctoData.status === "CP"
      ) {
        this.showModalDataOrcamento = true;
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    selecionaFormaPgto() {
      console.log("selecionaFormaPgto");
      if (
          this.paramOrctoConfParcFin === true
              ? this.orctoData.status === "EL"
              : this.orctoData.status === "EL" || this.orctoData.status === "CP"
      ) {
        this.showModalCondPgto = true;
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    selecionaPedTipo() {
      console.log("selecionaPedTipo");
      if (
          this.paramOrctoConfParcFin === true
              ? this.orctoData.status === "EL"
              : this.orctoData.status === "EL" || this.orctoData.status === "CP"
      ) {
        console.log(this.orctoData.tipo);
        this.showModalPedTipo = true;
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    selecionaNatureza() {
      console.log('selecionaNatureza')
      if (this.paramOrctoConfParcFin === true ? this.orctoData.status === 'EL' : this.orctoData.status === 'EL' || this.orctoData.status === 'CP') {
        console.log(this.orctoData.tipo)
        this.showModalNatureza = true
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    selecionaRepres() {
      console.log("selecionaRepres");
      if (this.orctoData.status === "EL") {
        console.log(this.orctoData.repres);

        this.showModalRepres = true;
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    selecionaTransp() {
      console.log("selecionaTransp");
      if (
          this.paramOrctoConfParcFin === true
              ? this.orctoData.status === "EL"
              : this.orctoData.status === "EL" || this.orctoData.status === "CP"
      ) {
        console.log(this.orctoData.repres);
        this.showModalTransp = true;
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    selecionaOrctoItem() {
      console.log("selecionaOrctoItem");
      if (
          this.paramOrctoConfParcFin === true
              ? this.orctoData.status === "EL"
              : this.orctoData.status === "EL" || this.orctoData.status === "CP"
      ) {
        this.showModalOrctoItem = true;
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    confirmarCliente() {
      console.log("confirmarCliente");
      this.showModalCliente = false;

      console.log("this.paramSugereItens");
      console.log(this.paramSugereItens);

      // if (this.paramSugereItens === true) {
      //   console.log('this.paramSugereItens')
      //   console.log(this.paramSugereItens)
      //   api.get(`${getBaseUrl()}api/cliultitens`, {
      //     params: { coddata: this.orctoData.cliente }
      //   }).then((res) => {
      //     console.log('then axios_confirmarCliente')
      //     console.log(res.data)
      //     this.showModalSugereItens = true
      //     this.orctoItensSugeridos = res.data[0]
      //   })
      // }

      this.salvarOrcamento();
    },

    confirmarDataOrcamento() {
      console.log("confirmarDataOrcamento");
      this.salvarOrcamento();
      this.showModalDataOrcamento = false;
    },

    confirmarFormaPgto() {
      console.log("confirmarFormaPgto");
      this.salvarOrcamento();
      this.showModalCondPgto = false;
    },

    confirmarPedTipo() {
      console.log("confirmarPedTipo");
      this.showModalPedTipo = false;
    },

    confirmarRepres() {
      console.log("confirmarRepres");
      this.salvarOrcamento();
      this.showModalRepres = false;
    },

    confirmarTransp() {
      console.log("confirmarTransp");
      this.showModalTransp = false;
    },

    confirmarOrctoItem() {
      console.log("confirmarOrctoItem");
      this.showModalOrctoItem = false;
    },

    confirmarFrete() {
      console.log("confirmarFrete");
      this.showModalFrete = false;
      this.salvarOrcamento();
    },

    confirmarDesconto() {
      console.log("confirmarDesconto");
      this.showModalDesconto = false;

      this.updating = true;

      this.errosValid = [];
      api
          .post(`${getBaseUrl()}api/orctodesc`, {
            iddata: this.idData,
            percdesc: this.orctoData.percdesc,
          })
          .then((res) => {
            console.log("then axios desconto");
            console.log(res);
            this.orctoData = res.data[0];
            this.updating = false;

            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações salvas com sucesso!",
              showConfirmButton: false,
              timer: 1500,
            });
          })
          .catch((err) => {
            console.log("erro axios");
            // console.log(err)
            // console.log(err.response)
            // console.log(err.response.data.errors)
            let erros = err.response.data.errors;
            console.log(erros);
            console.log(typeof erros);
            let listaErros = [];
            Object.keys(erros).forEach((key) => {
              console.log(key, erros[key]);
              listaErros.push({
                titulo: key,
                mensagem: erros[key],
              });
            });
            this.errosValid = listaErros;
            this.updating = false;
            this.activeTab = 0;
          });
    },

    pesqCliente(evt) {
      console.log("pesqCliente");
      console.log(evt);
      let query = evt;
      if (query.length > 1) {
        api
            .get(`${getBaseUrl()}api/clipesq`, {
              params: { q: query, c: "CL" },
            })
            .then((res) => {
              console.log("then axios");
              console.log(res.data);
              this.dtListPesqCli = res.data;
            });
      }
    },

    pesqCondPgto(evt) {
      console.log("pesqCondPgto");
      console.log(evt);
      let query = evt;

      console.log(query.length);
      if (query.length > 1) {
        this.loadingCondPgto = true;
        this.loadingFinanc = true;
        this.orctoData.condpgto = "";
        api
            .get(`${getBaseUrl()}api/cpgtopesq`, {
              params: { q: query },
            })
            .then((res) => {
              console.log("then axios");
              console.log(res.data);
              //console.log(res.data.length)
              this.dtListPesqCondPgto = res.data;
            });
      }
    },

    pesqFormaPgto(evt) {
      console.log("pesqFormaPgto");
      console.log(evt);
      let query = evt;
      console.log(query.length);
      if (query.length > 1) {
        this.loadingFormaPgto = true;
        this.loadingFinanc = true;
        this.orctoData.formapgto = "";
        api
            .get(`${getBaseUrl()}api/fpgtopesq`, {
              params: { q: query },
            })
            .then((res) => {
              console.log("then axios");
              console.log(res.data);
              //console.log(res.data.length)
              this.dtListPesqFormaPgto = res.data;
            });
      }
    },

    pesqNatureza(evt) {
      console.log('pesqNatureza')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1) {
        this.loadingPedTipo = true
        this.orctoData.tipo = ''
        api.get(`${getBaseUrl()}api/naturpesq`, {
          params: { q: query, t: 'S', f: this.orctoData.empresa }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtlistPesqNatureza = res.data
        })
      }
    },

    pesqPedTipo(evt) {
      console.log("pesqPedTipo");
      console.log(evt);
      let query = evt;
      console.log(query.length);
      if (query.length > 1) {
        this.loadingPedTipo = true;
        this.orctoData.tipo = "";
        api
            .get(`${getBaseUrl()}api/tpoprpesq`, {
              params: { q: query, t: "S", f: this.orctoData.empresa },
            })
            .then((res) => {
              console.log("then axios");
              console.log(res.data);
              //console.log(res.data.length)
              this.dtlistPesqPedTipo = res.data;
            });
      }
    },

    pesqRepres(evt) {
      console.log("pesqRepres");
      console.log(evt);

      let query = evt;
      console.log(query.length);
      if (query.length > 1) {
        this.loadingRepres = true;
        this.orctoData.repres = null;

        api.get(`${getBaseUrl()}api/reprpesq`, {
          params: { q: query, t: "S" },
        })
            .then((res) => {
              console.log("then axios reprpesq");
              console.log(res.data);

              if(res.data && res.data.length > 0) {
                this.dtListPesqRepres = res.data;
              }
            });
      }
    },

    pesqTransp(evt) {
      console.log("pesqTransp");
      console.log(evt);
      let query = evt;
      console.log(query.length);
      if (query.length > 1) {
        this.loadingTransp = true;
        this.orctoData.transp = "";
        api
            .get(`${getBaseUrl()}api/transpesq`, {
              params: { q: query },
            })
            .then((res) => {
              console.log("then axios");
              console.log(res.data);
              //console.log(res.data.length)
              this.dtListPesqTransp = res.data;
            });
      }
    },

    pesqFreteCota(evt) {
      console.log("pesqFreteCota");
      console.log(evt);
      let query = evt;
      console.log(query.length);
      if (query.length > 1) {
        // this.loadingTransp = true
        this.orctoData.transp = "";
        api
            .get(`${getBaseUrl()}api/pesqfretecota`, {
              params: { q: query },
            })
            .then((res) => {
              console.log("then axios");
              console.log(res.data);
              //console.log(res.data.length)
              this.dtListPesqFreteCota = res.data;
            });
      }
    },

    pesqOrctoItem(evt) {
      console.log("pesqOrctoItem_0");
      console.log(evt);
      let query = evt;
      console.log(query.length);
      if (query.length > 1) {
        this.dtlistPesqOrctoItem = null;
        this.loadingOrctoItem = true;
        api
            .get(`${getBaseUrl()}api/prodpesq`, {
              params: { q: query },
            })
            .then((res) => {
              console.log("then axios");
              console.log(res.data);
              // //console.log(res.data.length)
              this.dtlistPesqOrctoItem = res.data;

            this.dtlistPesqOrctoItem.forEach((value) => {
              if (value.imgs) {
                let imgTrat = value.imgs.split(",");
                value.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`;
              }
              value["descrcodigo"] =
                value["codigo"] +
                " " +
                value["descricao"] +
                " " +
                value["codbarra"];
            });
          });
      }
    },

    escolheuCli() {
      console.log("escolheuCli");
      this.loadingCliente = true;
      console.log(this.orctoData.cliente);
      api
        .get(`${getBaseUrl()}api/clicod`, {
          params: { coddata: this.orctoData.cliente },
        })
        .then((res) => {
          console.log("then axios");

          // console.log(res.data);
          this.clienteData = res.data[0];
          this.ultPedsData = res.data[1];

          console.log("clientes data:");
          console.log(res.data[1]);
          console.log("busca encerrada");

          let totalPed = 0;
          this.ultPedsData.forEach((value) => {
            totalPed += value.valorliq;
          });

          this.somaPedidosCli = totalPed;
          this.loadingCliente = false;
        });
    },

    escolheuCondPgto() {
      console.log("escolheuCondPgto");
      this.loadingCondPgto = true;
      this.loadingFinanc = true;

      console.log(this.orctoData.condpgto);
      api
        .get(`${getBaseUrl()}api/cpgtocod`, {
          params: { coddata: this.orctoData.condpgto },
        })
        .then((res) => {
          console.log("then axios");
          console.log(res.data);
          this.condPgtoData = res.data[0];
          this.ultPedsData = res.data[1];

          let totalPed = 0;
          this.ultPedsData.forEach((value) => {
            totalPed += value.valorliq;
          });

          this.financeiroData.condpgto = this.condPgtoData.codigo

          this.somaPedidosCli = totalPed;
          this.loadingCondPgto = false;
          this.loadingFinanc = false;
        });
    },

    escolheuFormaPgto() {
      console.log("escolheuFormaPgto");
      this.loadingFormaPgto = true;
      this.loadingFinanc = true;
      console.log(this.orctoData.formapgto);
      api
        .get(`${getBaseUrl()}api/fpgtocod`, {
          params: { coddata: this.orctoData.formapgto },
        })
        .then((res) => {
          console.log("then axios");
          console.log(res.data);
          this.formaPgtoData = res.data[0];
          this.ultPedsData = res.data[1];

          let totalPed = 0;
          this.ultPedsData.forEach((value) => {
            totalPed += value.valorliq;
          });

          this.financeiroData.formapgto = this.formaPgtoData.codigo

          this.somaPedidosCli = totalPed;
          this.loadingFormaPgto = false;
          this.loadingFinanc = false;
        });
    },

    escolheuPedTipo() {
      console.log("escolheuPedTipo");
      this.loadingPedTipo = true;
      console.log(this.orctoData.tipo);
      api
        .get(`${getBaseUrl()}api/tpoprcod`, {
          params: { coddata: this.orctoData.tipo },
        })
        .then((res) => {
          console.log("then axios_escolheu_ped_tipo");
          console.log(res.data);
          this.pedTipoData = res.data[0];
          this.ultPedsData = res.data[1];

          let totalPed = 0;
          this.ultPedsData.forEach((value) => {
            totalPed += value.valorliq;
          });

          this.somaPedidosCli = totalPed;
          this.loadingPedTipo = false;
        });
    },

    escolheuRepres() {
      console.log("escolheuRepres");
      this.loadingRepres = true;
      console.log(this.orctoData.repres);
      api
        .get(`${getBaseUrl()}api/reprcod`, {
          params: { coddata: this.orctoData.repres },
        })
        .then((res) => {
          console.log("then axios_escolheu_repres");
          console.log(res.data);
          this.represData = res.data[0];
          this.ultPedsData = res.data[1];

          let totalPed = 0;
          this.ultPedsData.forEach((value) => {
            totalPed += value.valorliq;
          });

          this.somaPedidosCli = totalPed;
          this.loadingRepres = false;
        });
    },

    escolheuTransp() {
      console.log("escolheuTransp");
      this.loadingTransp = true;
      console.log(this.orctoData.transp);
      api
        .get(`${getBaseUrl()}api/clicod`, {
          params: { coddata: this.orctoData.transp },
        })
        .then((res) => {
          console.log("then axios_escolheu_transp");
          console.log(res.data);
          this.transpData = res.data[0];
          this.loadingTransp = false;
        });
    },

    escolheuFreteCota() {
      console.log("escolheuFreteCota");
      //this.loadingTransp = true
      console.log(this.orctoData.segto);
      api
        .get(`${getBaseUrl()}api/fretecotacod`, {
          params: { coddata: this.orctoData.segto },
        })
        .then((res) => {
          console.log("then axios_escolheu_fretecota");
          console.log(res.data);
          this.freteCotaData = res.data[0];
          //this.loadingTransp = false
        });
    },

    escolheuOrctoItem() {
      console.log("escolheuItem");
      this.loadingOrctoItem = true;
      api
        .get(`${getBaseUrl()}api/prodcod`, {
          params: { coddata: this.orctoItemData.produto },
        })
        .then((res) => {
          console.log("then axios_escolheu_ped_item");
          console.log(res.data);

          let imgTrat = "";
          if (res.data[0]["imgs"]) {
            // img1 = res.data[0]['imgs']
            imgTrat = res.data[0]["imgs"].split(",");
            // this.produtoData.imgSTrat = `${getBaseUrl()}/uploads/imgprods/peq/${imgTrat[0]}`
          }

          this.orctoItemData = {
            orcamento_id: this.idData,
            produto_id: res.data[0]["id"],
            produto: res.data[0]["codigo"],
            descprod: res.data[0]["descricao"],
            und: res.data[0]["unidade"],
            deflote: res.data[0]['deflote'],
            vlrunitliq: res.data[0]["preco"],
            vlrunitbrt: res.data[0]["preco"],
            vlrtotalliq: res.data[0]["preco"],
            vlrtotalbrt: res.data[0]["preco"],
            saldo: res.data[0]["saldo"],
            pesobrtun: res.data[0]["pesobrt"],
            pesobrttot: res.data[0]["pesobrt"],
            pesoliqun: res.data[0]["pesoliq"],
            pesoliqtot: res.data[0]["pesoliq"],
            cubunt:
              res.data[0]["compr"] * res.data[0]["larg"] * res.data[0]["altu"],
            cubtot:
              res.data[0]["compr"] * res.data[0]["larg"] * res.data[0]["altu"],

            imgSTrat: `${getBaseUrl()}/uploads/imgprods/peq/${imgTrat[0]}`,
            qtd: 1,
          };

          console.log(`orctoItemData: ${this.orctoItemData}`);
          this.ultPedsData = res.data[1];

          let totalPed = 0;
          this.ultPedsData.forEach((value) => {
            totalPed += value.valorliq;
          });

          this.somaPedidosCli = totalPed;
          this.loadingOrctoItem = false;
        });
    },

    salvarOrcamento() {
      console.log("salvarOrcamento");

      if (this.orctoData.cliente && this.orctoData.cliente !== "") {
        console.log("salvarOrcamento_00");
        this.updating = true;

        this.errosValid = [];

        /**
         * Associando outros dados
         */
        if(this.financeiroData.banco) {
          this.orctoData.banco_id = this.financeiroData.banco
        }

        if(this.financeiroData.consutil) {
          this.orctoData.consutil = this.financeiroData.consutil
        }

        console.log('orct')
        console.log(this.orctoData)

        api
          .post(`${getBaseUrl()}api/orcamento`, {
            orctoData: this.orctoData,
          })
          .then((res) => {
            console.log("then axios");
            console.log(res);

            let success = res.data[0];

            if (!success) {
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: res.data[1],
                showConfirmButton: false,
                timer: 4000,
              });
            } else {
              this.orctoData = res.data[0];
              this.updating = false;

              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Informações salvas com sucesso!",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                this.orctoSalvo = true;
              });

              if (this.idData === 0) {
                console.log("redirecionar");
                this.$router.replace({
                  path: `/orcamento/editar/${this.orctoData.id}`,
                });
                this.idData = this.orctoData.id;
                this.carregarDados();
              }

              this.carregarDados();
              this.orctoSalvo = true;
            }
          })
          .catch((err) => {
            console.log("erro axios");
            // console.log(err)
            // console.log(err.response)
            // console.log(err.response.data.errors)
            let erros = err.response.data.errors;
            console.log(erros);
            console.log(typeof erros);
            let listaErros = [];
            Object.keys(erros).forEach((key) => {
              console.log(key, erros[key]);
              listaErros.push({
                titulo: key,
                mensagem: erros[key],
              });
            });
            this.errosValid = listaErros;
            this.updating = false;
            this.activeTab = 0;
          });
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor selecionar cliente antes de salvar o orçamento",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    carregouGrid(e) {
      console.log("carregouGrid");
      console.log(e)

      if (this.orctoData.id === 0) {
        this.title = "Novo Orçamento";
      } else {
        this.title = `Editando Orçamento: ${this.orctoData.id}`;
      }
    },

    onRowDblClick(row) {
      console.log("onRowDblClick");

      let idRow = row.data.id;
      let idProd = row.data.produto_id;
      let Prod = row.data.produto;

      this.idRow = idRow;
      this.idProd = idProd;
      this.Prod = Prod;
      // this.editarProduto(idProd);
      this.showModalAcao = true;
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "desconto") {
          const valdesconto = e.data.desconto;
          let cordesconto = "";

          if (valdesconto > 0.0) {
            cordesconto = "rgba(146,20,0,0.5)";
          } else if (valdesconto <= 0.0) {
            cordesconto = "rgba(33,78,0,0.5)";
          }

          if (cordesconto) {
            e.cellElement.style.cssText = `color: white; background-color: ${cordesconto}`;
          } else {
            e.cellElement.style.cssText = "";
          }
        }

        if (e.column.dataField === "aconferirqtd") {
          const valaconferir = e.data.aconferirqtd;
          const qtd = e.data.qtd;
          let coraconferir = "";

          if (valaconferir > 0.0 && valaconferir === qtd) {
            coraconferir = "";
          } else if (valaconferir > 0.0) {
            coraconferir = "rgba(191,147,9,0.5)";
          } else if (valaconferir === 0.0) {
            coraconferir = "rgba(33,78,0,0.5)";
          }

          if (coraconferir) {
            e.cellElement.style.cssText = `color: white; background-color: ${coraconferir}`;
          } else {
            e.cellElement.style.cssText = "";
          }
        }

        if (e.column.dataField === "conferidoqtd") {
          const valconferir = e.data.conferidoqtd;
          const qtd = e.data.qtd;
          let corconferir = "";

          if (valconferir === 0.0) {
            corconferir = "";
          } else if (valconferir > 0.0 && valconferir < qtd) {
            corconferir = "rgba(191,147,9,0.5)";
          } else if (valconferir === qtd) {
            corconferir = "rgba(33,78,0,0.5)";
          }

          if (corconferir) {
            e.cellElement.style.cssText = `color: white; background-color: ${corconferir}`;
          } else {
            e.cellElement.style.cssText = "";
          }
        }

        if (e.column.dataField === "qtddisp") {
          const valaconferir = e.data.qtddisp;
          const qtd = e.data.qtd;
          let coraconferir = "";

          if (valaconferir > 0.0 && valaconferir === qtd) {
            coraconferir = "";
          } else if (valaconferir > 0.0) {
            coraconferir = "rgba(191,147,9,0.5)";
          } else if (valaconferir === 0.0) {
            coraconferir = "rgba(33,78,0,0.5)";
          }

          if (coraconferir) {
            e.cellElement.style.cssText = `color: white; background-color: ${coraconferir}`;
          } else {
            e.cellElement.style.cssText = "";
          }
        }

        if (e.column.dataField === "qtdlida") {
          const valconferir = e.data.qtdlida;
          const qtd = e.data.qtd;
          let corconferir = "";

          if (valconferir === 0.0) {
            corconferir = "";
          } else if (valconferir > 0.0 && valconferir < qtd) {
            corconferir = "rgba(191,147,9,0.5)";
          } else if (valconferir === qtd) {
            corconferir = "rgba(33,78,0,0.5)";
          }

          if (corconferir) {
            e.cellElement.style.cssText = `color: white; background-color: ${corconferir}`;
          } else {
            e.cellElement.style.cssText = "";
          }
        }

        if (e.column.dataField === "status") {
          const valstatus = e.data.status;
          let corconferir = "";

          if (valstatus === "ES") {
            corconferir = "rgba(6,119,221,0.85)";
          } else if (valstatus === "AB") {
            corconferir = "rgba(191,147,9,0.5)";
          } else if (valstatus === "SE") {
            corconferir = "rgba(33,78,0,0.5)";
          } else if (valstatus === "CP") {
            corconferir = "rgb(51,122,183)";
          } else if (valstatus === "CA") {
            corconferir = "rgba(254,32, 32, 0.5)";
          }

          if (corconferir) {
            e.cellElement.style.cssText = `color: white; background-color: ${corconferir}`;
          } else {
            e.cellElement.style.cssText = "";
          }
        }
      }
    },

    onExporting(e) {
      console.log("onExporting");
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("plan1");
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            this.title + ".xlsx"
          );
        });
      });
      e.cancel = true;
    },

    refeFormTable() {
      console.log("refeFormTable");
      this.dataGrid.state(null);
    },

    nomeStatus(e) {
      // console.log(`status: ${e}`)

      switch (e) {
        case "FA":
          return "Faturado (FA)";
        case "EL":
          return "Em Elaboração (EL)";
        case "CP":
          return "Conf. Parcial (CP)";
        case "CO":
          return "Confirmado (CO)";
        case "SC":
          return "Solicitação de cancelamento (SC)";
        case "CA":
          return "Cancelado (CA)";
      }

      return "Não Definido";
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value);
        return value_n.toLocaleString("pt-BR", {
          style: "decimal",
          minimumFractionDigits: 2,
        });
      }
      return "0,00";
    },

    formatBigDecimal(value) {
       //console.log('formatBigDecimal')
       //console.log(value)
       //console.log(typeof value)

      if (value) {
        let value_n = parseFloat(value);
        return value_n.toLocaleString("pt-BR", {
          style: "decimal",
          minimumFractionDigits: 4,
        });
      } else {
        //console.log("bigfloat convertion error");
        return "0,00";
      }
    },

    formatDecimalQuatro(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value);
        return value_n.toLocaleString("pt-BR", {
          style: "decimal",
          minimumFractionDigits: 4,
        });
      }
      return "0,00";
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value);
        return value_n.toLocaleString("pt-BR", {
          style: "decimal",
          minimumFractionDigits: 0,
        });
      }
      return 0.0;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss";
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime;
    },

    formatDate(value) {
      // console.log('value formatDate')
      var dateString = value;
      var momentObj = moment(dateString, "YYYY-MM-DD");
      // console.log(momentObj)
      const formatSaida = "DD/MM/YYYY";
      let dateTime = momentObj.format(formatSaida);
      // console.log(dateTime)
      return dateTime;
    },

    formatBoolean(e){
      //console.log('formatBoolean: ')
      //console.log(e.value)

      if(e.value === false){
        return "Não"
      } else {
        return "Sim"
      }
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader
      :title="title"
      :items="items"
      :status="nomeStatus(orctoData.status)"
    />

    <Loader v-if="updating" style="min-height: 400px"> </Loader>

    <div class="row" v-if="!updating">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">
              <b-button
                variant="outline-primary"
                class="mx-2"
                @click="salvarOrcamento"
                :disabled="orctoData.status === 'CO'"
              >
                <i class="bx bx-save font-size-16 align-middle me-2"></i>
                Salvar Alterações
              </b-button>

              <b-button
                variant="outline-info"
                class="mx-2"
                v-if="idData > 0 && orctoData.status !== 'SC'"
                @click="imprimirOrcamento"
              >
                <i class="bx bx-printer font-size-16 align-middle me-2"></i>
                Imprimir
              </b-button>

              <b-button
                variant="outline-info"
                class="mx-2"
                v-if="idData > 0 && orctoData.status !== 'SC'"
                @click="copiarOrcamento"
              >
                <i class="bx bx-copy font-size-16 align-middle me-2"></i>
                Copiar
              </b-button>

              <b-button variant="outline-primary" class="mx-2" v-if="idData > 0" @click="redirecionarOrcamentoWMS">
                <i class="bx bxs-directions font-size-16 align-middle me-2"></i>
                Redirecionar
              </b-button>

              <!--              <b-button variant="outline-info" class="mx-2" v-if="idData > 0" @click="copiarOrcamento02">-->
              <!--                <i class="bx bx-copy font-size-16 align-middle me-2" ></i>-->
              <!--                Copiar - 02-->
              <!--              </b-button>-->

              <b-button
                variant="outline-success"
                class="mx-2"
                @click="reverterCancelarOrcto"
                v-if="orctoData.status === 'SC'"
              >
                <i class="bx bx-arrow-back font-size-16 align-middle me-2"></i>
                Não cancelar orçamento
              </b-button>

              <b-button
                variant="outline-danger"
                class="mx-2"
                @click="cancelarOrcamento"
                :disabled="orctoData.id === 0 || orctoData.status === 'CO' || orctoData.status === 'CP' && orctoData.status === 'CA'"
              >
                <i class="bx bxs-trash font-size-16 align-middle me-2"></i>
                Cancelar orçamento
              </b-button>

              <b-button
                variant="outline-warning"
                class="mx-2"
                @click="novoProduto"
                :disabled="orctoData.id === 0 || orctoData.status === 'CO'"
              >
                <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                Novo Produto
              </b-button>

              <!--<b-button variant="outline-primary" class="mx-2" @click="auditoria" :disabled="orctoData.id === 0" v-if="orctoData.status !== 'SC'">
                <i class="bx bx-search-alt font-size-16 align-middle me-2"></i>
                Auditoria
              </b-button>-->

              <b-button
                variant="outline-info"
                class="mx-2"
                @click="cotarFrete"
                :disabled="orctoData.id === 0 || orctoData.status === 'EL'"
              >
                <i class="bx bxs-truck font-size-16 align-middle me-2"></i>
                Cotar Frete
              </b-button>

              <b-button
                variant="outline-success"
                class="mx-2"
                @click="novoPagamento"
                :disabled="orctoData.id === 0 || orctoData.status !== 'EL'"
              >
                <i
                  class="bx bxs-dollar-circle font-size-16 align-middle me-2"
                ></i>
                Novo Pagamento
              </b-button>

              <b-button
                variant="outline-info"
                class="mx-2"
                @click="showModalAddCampanha = true"
                :disabled="orctoData.id === 0 || orctoData.status === 'CO' || orctoData.status === 'CP'"
                v-if="flagCampanhaParam"
              >
                <i class="bx bx-sticker font-size-16 align-middle me-2"></i>
                Adicionar Campanha
              </b-button>

              <b-button variant="outline-danger" class="mx-2" @click="fecharOrcamento" v-if="orctoData.id > 0 && (orctoData.status === 'CP' || orctoData.status === 'EL')">
                <i class="bx bx-x font-size-16 align-middle me-2"></i>
                Fechar Orçamento
              </b-button>

              <b-button variant="outline-info" class="mx-2" @click="showModalIndicaPedido = true"
                :disabled="orctoData.status !== 'EL'"
                v-if="flagAgregacaoPedido"
              >
                <i class="bx bx-analyse font-size-16 align-middle me-2"></i>
                Agregar a pedido
              </b-button>

              <!--                    <span-->
              <!--                        class="avatar-title rounded-circle bg-soft bg-warning text-warning font-size-22"-->
              <!--                    >-->
              <!--                      <i class="mdi mdi-cash"></i>-->
              <!--                    </span>-->
              <div class="flex-grow-1 align-self-center">
                <div class="text-muted">
                  <!--                  <h5>R$ 4.855.745,00 (recebíveis hoje)</h5>-->
                  <!--                  <p class="mb-1">R$ 978.444,00 a pagar hoje</p>-->
                  <!--                  <p class="mb-0">Id no: #SK0234</p>-->
                </div>
              </div>

              <button
                class="btn btn-success"
                @click="confirmarOrcamento"
                :disabled="orctoData.id === 0 || orctoData.status === 'CO' || orctoData.status === 'CP' || disableButton"
                v-if="
                  orctoItensData &&
                  orctoItensData.length > 0"
              >
                <i class="mdi mdi-rocket-launch me-1 text-end"></i> SUCESSO!
              </button>
            </div>
          </div>
        </div>
      </div>

      <b-alert
        v-for="(erro, i) in errosValid"
        :key="`alerta-${i}`"
        show
        dismissible
        variant="danger"
      >
        <i class="mdi mdi-alert me-2"></i>Pendente validação de campo:
        {{ erro.titulo }} -- {{ erro.mensagem[0] }} -- favor ajustar e tentar
        novamente.
      </b-alert>

      <div class="col-xl-4">
        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <div class="me-3">
                <!--                <img-->
                <!--                    src="@/assets/images/users/avatar-2.jpg"-->
                <!--                    alt=""-->
                <!--                    class="avatar-sm rounded-circle img-thumbnail"-->
                <!--                />-->
                <span
                  v-if="clienteData"
                  class="avatar-title rounded-circle"
                  style="max-height: 55px; min-width: 55px"
                  >{{ clienteData.codigo }}
                </span>
              </div>
              <div class="flex-grow-1">
                <div class="d-flex">
                  <div class="flex-grow-1">
                    <h6 class="mb-1 text-muted">Cliente:</h6>
                    <div class="text-muted">
                      <a
                        href="javascript: void(0);"
                        v-if="!clienteData"
                        @click="selecionaCli"
                      >
                        <h5 class="mb-1 text-info">Selecionar cliente ...</h5>
                      </a>

                      <a
                        href="javascript: void(0);"
                        v-if="clienteData"
                        v-b-tooltip.hover
                        placement="top"
                        title="Alterar cliente"
                        @click="selecionaCli"
                      >
                        <h5 class="mb-1">
                          {{ clienteData.codigo }} - {{ clienteData.nome }}
                        </h5>
                        <p class="mb-0">
                          {{ clienteData.cidade }}, {{ clienteData.estado }}
                        </p>
                      </a>
                    </div>
                  </div>

                  <router-link
                    :to="`/cliente/editar/${clienteData.id}`"
                    class="ms-2"
                    v-if="clienteData"
                    target="_blank"
                  >
                    Detalhes Cliente
                    <i class="mdi mdi-arrow-right ms-1"></i>
                  </router-link>
                </div>

                <hr />

                <div>
                  <h6 class="mb-1 text-muted">Representante:</h6>
                  <div class="text-muted">
                    <a
                      href="javascript: void(0);"
                      v-if="!represData"
                      @click="selecionaRepres"
                    >
                      <h5 class="mb-1 text-info">
                        Selecionar representante ...
                      </h5>
                    </a>

                    <a
                      href="javascript: void(0);"
                      v-if="represData"
                      v-b-tooltip.hover
                      placement="top"
                      title="Alterar Representante"
                      @click="selecionaRepres"
                    >
                      <h5 class="mb-1">
                        {{ represData.codigo }} - {{ represData.descricao }}
                      </h5>
                      <p class="mb-0">
                        {{ represData.cidade }}, {{ represData.estado }}
                      </p>
                    </a>
                  </div>
                </div>

                <hr />
                <div class="row">
                  <h4>Totais</h4>
                  <div class="col-4">
                    <div>
                      <p class="text-muted text-truncate mb-2">Valor total</p>
                      <h6 class="mb-0">
                        R$
                        {{
                          orctoData.valorliq ??
                          formatDecimal(orctoData.valorliq)
                        }}
                      </h6>
                    </div>
                  </div>

                  <div class="col-3">
                    <div>
                      <p class="text-muted text-truncate mb-2">Peso total</p>
                      <h6 class="mb-0">
                        {{
                          orctoData.pesobrt ?? formatDecimal(orctoData.pesobrt)
                        }}
                        kg
                      </h6>
                    </div>
                  </div>

                  <div class="col-3">
                    <div>
                      <p class="text-muted text-truncate mb-2">Cubagem</p>
                      <h6 class="mb-0">
                        {{
                          orctoData.cubtot ?? formatDecimal(orctoData.cubtot)
                        }}
                        m³
                      </h6>
                    </div>
                  </div>
                </div>
                <br>

                <!--Campanha orcamento-->
                <div class="row" v-if="flagCampanhaParam">
                  <hr>
                  <div class="d-flex">
                    <h4>Campanha Selecionada</h4>
                    <i v-if="this.orctoData.status === 'EL' || this.orctoData.status === 'CP'" style="cursor:pointer" class="bx bx-x font-size-20 align-middle me-2 text-danger mt-1"
                    @click="removerCampanha"
                    title="Remover Campanha"></i>
                  </div>

                  <div class="col-4">
                    <div>
                      <p class="text-muted text-truncate mb-2">Código</p>
                      <h6 class="mb-0">{{ campanhaSelected.codigo }}</h6>
                    </div>
                  </div>

                  <div class="col-3">
                    <div>
                      <p class="text-muted text-truncate mb-2">Descrição</p>
                      <h6 class="mb-0">{{ campanhaSelected.descricao }}</h6>
                    </div>
                  </div>
                </div>

                <!--pedido agregado-->
                <div class="row" v-if="orctoData.agregped_id && orctoData.agregped_id > 0">
                  <hr>
                  <div class="d-flex">
                    <h4>Pedido Associado</h4>
                    <i v-if="this.orctoData.status === 'EL' || this.orctoData.status === 'CP'" variant="outline-danger" style="cursor:pointer" class="bx bx-x font-size-20 align-middle me-2 text-danger mt-1"
                      @click="removerPedAssoc"
                      title="Remover pedido associado"></i>
                  </div>

                  <div class="col-4">
                    <div>
                      <p class="text-muted text-truncate mb-2">ID Pedido a agregar</p>
                      <h6 class="mb-0">{{ orctoData.agregped_id ?? "-" }}</h6>
                    </div>
                  </div>
                  <br>
                </div>



              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <!--natureza da operação-->
            <div class="row">
              <div class="d-flex" v-if="orctoData.tipo">
                <h4>Natureza da operação</h4>
                <i style="cursor:pointer" class="bx bx-x font-size-20 align-middle me-2 text-danger mt-1"
                @click="removerNatureza"
                title="Remover Natureza da operação"
                v-if="naturezaData.id || orctoData.tipo"></i>
              </div>

              <h6 class="text-muted" style="cursor:pointer" v-if="orctoData.tipo !== null || orctoData.tipo !== ''">
                <i class="bx bx-pencil font-size-20 align-middle mx-2"
                @click="editarNaturezas"></i>
                Acessar Naturezas
              </h6>

              <div class="mt-1">
                <div class="mt-2 d-flex" v-if="naturezaData.cfopicms">
                    <p class="text-muted ms-1">CFOP: </p>
                    <span class="mx-1"></span>
                    <h6 class="mt-1">{{ naturezaData.cfopicms }}</h6>
                </div>

                <div class="d-flex" v-if="naturezaData.descricao">
                    <p class="text-muted">Descrição: </p>
                    <span class="mx-1"></span>
                    <h6 class="mt-1">{{ naturezaData.descricao }}</h6>
                </div>
              </div>

              <b-button variant="outline-warning" class="mx-2" @click="showModalNatureza = true"
                :disabled="orctoData.status !== 'EL'"
              >
                <i class="bx bx-dollar font-size-16 align-middle me-2"></i>
                {{ orctoData.idData === 0 ? 'Selecionar Natureza de Operação' : 'Alterar Natureza de Operação'  }}
              </b-button>
            </div>

            <hr />
            <div class="row">
              <div class="d-flex" v-if="orctoData.tipo">
                <h4>Dados Financeiros:</h4>
                <h6 class="text-muted ms-auto"
                    style="cursor:pointer;"
                    v-if="orctoData.tipo !== null || orctoData.tipo !== ''"
                    @click="editarFinanceiro">
                  <i class="bx bx-pencil font-size-12 align-middle mx-1"/>
                  Editar Dados Financeiros
                </h6>
              </div>

              <div class="row">
                <div class="d-flex col-sm-6 mt-2">
                  <h6 class="">Cond. Pgto:
                    <span class="text-muted ms-2">{{ financeiroData?.condpgto }}</span>
                  </h6>
                </div>

                <div class="d-flex col-sm-6 mt-2">
                  <h6 class="">Forma Pgto:
                    <span class="text-muted ms-2" style="">{{ financeiroData?.formapgto}}</span>
                  </h6>
                </div>

                <div class="d-flex col-sm-6">
                  <h6 class="">Banco:
                    <span class="text-muted ms-2" style="">( {{ financeiroData?.banco}} - {{ financeiroData?.descricao}} )</span>
                  </h6>
                </div>

                <div class="d-flex col-sm-6">
                  <h6 class="">Cons. dia útel::
                    <span class="text-muted ms-2" style="">{{ financeiroData?.consutil}}</span>
                  </h6>
                </div>
              </div>
            </div>

            <hr />
            <h4>Outros dados Orçamento:</h4>
            <div class="row text-end">
              <b-dropdown
                toggle-class="text-muted font-size-16 p-0"
                variant="white"
                right
                class="ms-auto"
                menu-class="dropdown-menu-end"
              >
                <template #button-content>
                  <i class="mdi mdi-dots-horizontal"></i>
                </template>
                <b-dropdown-item href="#" @click="selecionaCli"
                  >Alterar Cliente</b-dropdown-item>

                <!--<b-dropdown-item href="#" @click="editaDataOrcamento"
                >Alterar Data do Orçamento</b-dropdown-item>-->

<!--                <b-dropdown-item href="#" @click="selecionaFormaPgto"
                  >Alterar Forma de Pagamento</b-dropdown-item
                >-->
                <b-dropdown-divider></b-dropdown-divider>
                <!--<b-dropdown-item href="#" @click="selecionaPedTipo"
                  >Alterar Tipo de Operação</b-dropdown-item
                >-->
                <b-dropdown-item href="#" @click="selecionaRepres"
                  >Alterar Representante</b-dropdown-item
                >
                <b-dropdown-item href="#" @click="selecionaTransp"
                  >Alterar Transportadora</b-dropdown-item
                >
              </b-dropdown>
            </div>

            <div>
              <div>
                <!--                <div class="d-flex mb-1 align-items-baseline">
                  <div class="d-flex">
                    <i style="cursor:pointer; font-size: 1rem;" class="bx bx-x text-danger"
                      @click="orctoData.formapgto = null"
                      title="Remover tipo pagamento"
                      v-if="orctoData.formapgto !== null || orctoData.formapgto !== ''"></i>
                    <h6 >Condição de pagamento: </h6>
                  </div>

                  <a
                    href="javascript: void(0);"
                    v-if="formaPgtoData"
                    v-b-tooltip.hover
                    placement="top"
                    title="Alterar forma de pagamento"
                    @click="selecionaFormaPgto"
                    class="mx-3"
                  >
                    <p class="text-muted">
                      {{ formaPgtoData != null ? `${formaPgtoData.descricao} (cód.: ${orctoData.formapgto})` : "Selecionar tipo pagamento" }}
                    </p>
                  </a>
                </div>-->
                <div class="d-flex mb-1 align-items-baseline">
                  <div class="d-flex">
                    <i style="cursor:pointer; font-size: 1rem;" class="bx bx-x text-danger"
                      v-if="orctoData.transp !== null || orctoData.transp !== ''"
                      @click="orctoData.transp = null"
                      title="Remover transportadora"></i>
                      <h6 >Transportadora: </h6>
                  </div>

                  <a
                    href="javascript: void(0);"
                    v-b-tooltip.hover
                    placement="top"
                    title="Alterar transportadora"
                    @click="alteraTransp"
                    class="mx-3"
                  >
                    <p class="text-muted">
                        {{ transportadora.cnpj != null ? transportadora.nome + ' - ' + transportadora.cnpj : "Sem Transportadora" }}
                      <i class="mdi mdi-truck-outline ms-1"></i>
                    </p>
                  </a>
                </div>
              </div>

              <div class="d-flex mb-1 align-items-baseline">
                <div class="d-flex">
                  <i style="cursor:pointer; font-size: 1rem;" class="bx bx-x text-danger"
                    @click="orctoData.repres = null"
                    title="Remover representante"
                    v-if="orctoData.repres !== null || orctoData.repres !== ''"></i>
                    <h6 >Representante: </h6>
                </div>
                <a
                  href="javascript: void(0);"
                  v-b-tooltip.hover
                  placement="top"
                  title="Alterar representante"
                  @click="selecionaRepres"
                  class="mx-3"
                >
                  <p class="text-muted" v-if="Array.isArray(represData) && represData.length > 0 && represData.includes(represData.descricao)">
                    {{ orctoData.repres != null ? represData.descricao : "Sem Representante" }}
                  </p>
                </a>
              </div>
            </div>

            <hr />

            <div class="d-flex flex-wrap">
              <div>
                <a
                  href="javascript: void(0);"
                  v-b-tooltip.hover
                  placement="top"
                  title="Alterar observações"
                  @click="alteraObs"
                >
                  <p class="text-warning mb-0">
                    <span>
                      {{
                        orctoData.obs != null
                          ? orctoData.obs
                          : "Observações do Pedido"
                      }}
                      <i class="mdi mdi-chat-alert ms-1"></i>
                    </span>
                  </p>
                </a>
              </div>
            </div>

            <div v-if="orctoData.obsnf" class="d-flex flex-wrap text-end">
              <div>
                <a
                  href="javascript: void(0);"
                  v-b-tooltip.hover
                  placement="top"
                  title="Alterar observações"
                  @click="alteraObs"
                >
                  <p class="text-black mb-0">
                    <span>
                      {{
                        orctoData.obsnf != null
                          ? orctoData.obsnf
                          : "Observações da Nota Fiscal"
                      }}
                      <i class="mdi mdi-chat-alert ms-1"></i>
                    </span>
                  </p>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="card" v-if="orctoData">
          <div class="card-body">
            <h4 class="card-title mb-3">Detalhamento do orçamento</h4>

            <div class="d-flex justify-content-sm-between">
              <div class="col-4">
                <div>
                  <p class="text-muted text-truncate mb-2">Data do orçamento</p>
                  <h6 class="mb-0">{{ formatDate(orctoData.dtemissao) }}</h6>
                </div>
              </div>

              <div class="col-4">
                <div>
                  <p class="text-muted text-truncate mb-2">Código</p>
                  <h6 class="mb-0">{{ orctoData.codigo }}</h6>
                </div>
              </div>
            </div>
            <hr />

            <div class="table-responsive">
              <table class="table mb-0">
                <tbody>
                  <tr>
                    <td>Usuário</td>
                    <td class="float-end">{{ orctoData.created_by }}</td>
                  </tr>

                  <tr>
                    <td>Valor Total Bruto</td>
                    <td class="float-end">
                      R$ {{ formatBigDecimal(orctoData.valorbrt) }}
                    </td>
                  </tr>

                  <tr>
                    <td>Qtd. Total Produtos</td>
                    <td class="float-end">
                      {{ formatInteger(this.countOrctoItens) }}
                    </td>
                  </tr>



                  <tr>
                    <td>Qtd. Total Itens</td>
                    <td class="float-end">
                      {{ formatDecimal(this.qtdTotalItens) }} und.
                    </td>
                  </tr>

                  <tr>
                    <td>Valor Desconto Itens</td>
                    <td class="float-end">
                      R$ {{ formatBigDecimal(orctoData.desconto) }}
                    </td>
                  </tr>

                  <tr>
                    <td>Valor Total Produtos</td>
                    <td class="float-end">
                      R$ {{ formatBigDecimal(orctoData.valorprd) }}
                    </td>
                  </tr>

                  <tr>
                    <td>Desconto Pedido</td>
                    <!--                  <td class="float-end">R$ {{ formatDecimal(orctoData.desconto) }}</td>-->

                    <td class="d-flex float-end">
                      <div class="d-flex justify-content-end">
                        <i class="font-size-16 bx-fade-left"></i>
                      </div>

                      <!-- LINK DE MODAL PARA ALTERAÇÃO DO PERCENTUAL DE DESCONTO DESABILITADO -->
                      <!-- <a href="javascript: void(0);"
                       v-b-tooltip.hover
                       placement="top"
                       title="Alterar porcentagem de desconto"> -->
                      <p class="mb-0">
                        <span>
                          {{
                            orctoData.percdesc != null
                              ? formatDecimal(orctoData.percdesc)
                              : "0,00"
                          }}
                          %
                        </span>
                      </p>
                      <!-- </a> -->
                    </td>
                  </tr>

                  <tr>
                    <td>Margem Bruta (média)</td>
                    <td class="float-end">
                      {{ formatDecimal(orctoData.margem) }} %
                    </td>
                  </tr>

                  <tr>
                    <td>Valor Frete</td>
                    <td class="float-end d-flex">
                      <div class="d-flex justify-content-end">
                        <i class="font-size-16 bx-fade-left"></i>
                      </div>

                      <div v-b-tooltip.hover placement="top">
                        <p class="mb-0">
                          <span>
                            R$
                            {{
                              orctoData.valorfrt != null
                                ? formatBigDecimal(orctoData.valorfrt)
                                : "0,00"
                            }}
                            <!--@click="alteraFrete" - Função desabilitada porque Evandro pediu para deixar o valor da cotação realizada! - Pablo>-->
                          </span>
                        </p>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <a
                        href="javascript: void(0);"
                        v-b-tooltip.hover
                        placement="top"
                        title="Editar código de carga"
                        @click="abrirModalCarga"
                      >
                        Carga ({{ orctoData.carga }})
                      </a>
                    </td>
                    <td class="float-end d-flex">
                      <div class="d-flex justify-content-end">
                        <i class="font-size-16 bx-fade-left"></i>
                      </div>

                      <div v-b-tooltip.hover placement="top">
                        <p class="mb-0">
                          <span>
                            <h6 class="mb-0">
                              {{
                                orctoData.cubcarga ??
                                formatDecimal(orctoData.cubcarga)
                              }}
                              m³
                            </h6>
                          </span>
                        </p>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <th>Valor Total Líquido</th>
                    <th class="float-end">
                      R$ {{ formatBigDecimal(orctoData.valorliq) }}
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="card" v-if="orctoData">
          <div class="card-body">
            <h4 class="card-title mb-3">Pagamentos</h4>

          </div>

          <div class="card-body">
            <h4 class="card-title mb-3">Pagamentos</h4>

            <div class="table-responsive">
              <table class="table mb-0">
                <tbody>
                  <tr v-for="data in orctoFinansData" :key="data.id">
                    <td>
                      <a
                        href="javascript: void(0);"
                        v-b-tooltip.hover
                        placement="top"
                        title="Editar pagamento"
                        @click="alteraPagamento(data)"
                      >
                        {{ data.formapgtodesc }} | {{ data.obs }}
                      </a>
                    </td>

                    <td class="float-end">
                      <a
                        href="javascript: void(0);"
                        v-b-tooltip.hover
                        placement="top"
                        title="Editar pagamento"
                        @click="alteraPagamento(data)"
                      >
                        {{ formatDecimal(data.valor) }}
                      </a>
                    </td>
                  </tr>

                  <tr>
                    <td>Valor Total Pagamentos</td>
                    <td class="float-end">
                      R$ {{ formatDecimal(valorTotalFinanc) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- end table-responsive -->
          </div>
        </div>
      </div>

      <div class="col-xl-8">
        <div class="card">
          <div class="card-body">
            <ul class="nav nav-tabs">
              <li class="nav-item" v-for="tab in tabs" :key="tab.name">
                <a
                  class="nav-link"
                  :class="{ active: currentTab === tab.name }"
                  href="javascript:void(0);"
                  @click="selectTab(tab.name)"
                >
                  {{ tab.label }}
                </a>
              </li>
            </ul>

            <!-- Painéis -->
            <div v-if="currentTab === 'ItensOrcamento'">
              <div class="row">
                <div class="card-body">
                  <!--                  <div class="table-responsive">
                    <table class="table align-middle mb-0 table-nowrap">
                      <thead class="table-light">
                      <tr>
                        <th>Produtos ({{ orctoItensData !== null ? orctoItensData.length : 0 }})</th>
                        <th>Descrição</th>
                        <th class="text-center">Valor Unit.(R$)</th>
                        <th class="text-center">Peso total</th>
                        <th class="text-center">Cubagem total</th>
                        <th class="text-center">Quantidade</th>
                        <th class="text-center">A conferir</th> &lt;!&ndash; saldo restante de wmsos &ndash;&gt;
                        <th class="text-center">Margem(%)</th>
                        <th class="text-center">Desconto unitário(R$)</th>
                        <th class="text-center">Total Líquido(R$)</th>
                        <th class="text-center">Ações</th>
                      </tr>
                      </thead>
                      <tbody>

                      <tr v-for="data in orctoItensData" :key="data.id">

                        <td>
                          <h5 class="text-muted mb-0">{{ data.produto }} </h5>

                          <img v-if="data.img1" :src="data.img1" alt="product-img" title="product-img" class="avatar-md" />

                          <div class="mb-3" v-else>
                            <i class="bx bxs-camera-off h2 text-warning" title="Produto sem foto"></i>
                          </div>

                        </td>

                        <td>
                          <h5 class="font-size-14 text-truncate">
                            <a href="javascript: void(0);" class="text-body fw-bold text-wrap"
                               @click="editarProduto(data.id)">
                              {{ data.descprod }}
                            </a>
                          </h5>
                          <p class="mb-0">
                            &lt;!&ndash;                      Saldo:&ndash;&gt;
                            &lt;!&ndash;                      <span class="fw-medium"> {{ formatInteger(data.id)  }} </span>&ndash;&gt;
                          </p>
                        </td>

                        <td class="text-end">{{ formatDecimal(data.vlrunitbrt) }}</td>
                        <td class="text-center">{{ formatDecimal(data.pesobrttot) }}Kg</td>
                        <td class="text-center">{{ data.cubtot }}m³</td>
                        <td class="text-center">{{ formatDecimal(data.qtd) }}</td>
                        <td class="center">
                          <i class="bx bx-package"></i>
                          <span :class="data.aconferirqtd > 1 ? 'badge-soft-warning' :
                                      data.aconferirqtd == 0 ? 'badge-soft-success' :
                                      'badge-soft-danger'
                          ">
                          {{ formatDecimal(data.aconferirqtd) }}
                        </span>
                        </td>
                        <td class="text-center">{{ formatDecimal(data.margem) }}</td>

                        <td class="text-end">
                      <span class="badge badge-pill badge-soft-success font-size-11" v-if="data.desconto !== 0.00"
                            :class="data.desconto < 0.00 ? 'badge-soft-success' :
                          data.desconto > 0 ? 'badge-soft-danger' : ''">
                        {{ formatDecimal(data.desconto) }}
                      </span>
                          <span v-else>
                        0.00
                      </span>
                        </td>

                        <td class="text-end">{{ formatDecimal(data.vlrtotalliq) }}</td>

                        <td class="text-end">

                          <a href="javascript:void(0);" class="action-icon text-success mx-2"
                             @click="detalhesProduto(data.produto_id)">
                            <i class="mdi mdi-eye font-size-18"></i>
                          </a>

                          <a href="javascript:void(0);" v-if="orctoData.status === 'EL'"
                             class="action-icon text-warning mx-2" @click="editarProduto(data.id)">
                            <i class="mdi mdi-pencil-outline font-size-18"></i>
                          </a>

                          <a href="javascript:void(0);" v-if="orctoData.status === 'EL'"
                             class="action-icon text-danger mx-2" @click="deletarOrctoItem(data.id)">
                            <i class="mdi mdi-trash-can font-size-18"></i>
                          </a>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>-->
                  <div>
                    <DxToolbar>
                      <DxItem location="before" widget="dxButton">
                        <DxButton
                          icon="refresh"
                          hint="Redefinir formatação de tabela para padrão"
                          :on-click="refeFormTable"
                        />
                      </DxItem>

                      <DxItem location="before" widget="dxButton">
                        <DxButton
                            icon="clear"
                            hint="Desconsiderar validação de item no fluxo de saldo"
                            text="Desconsiderar validação de item"
                            :on-click="desconsiderarSaldoItens"
                        />
                      </DxItem>

                      <DxItem location="before" widget="dxButton">
                        <DxButton
                            icon="revert"
                            hint="Reconsiderar validação de item no fluxo de saldo"
                            text="Reconsiderar validação de item"
                            :on-click="reconsiderarSaldoItens"
                        />
                      </DxItem>
                    </DxToolbar>
                  </div>

                  <Loader v-if="updating" style="min-height: 300px"> </Loader>

                  <div class="mt-2" v-if="!updating">
                    <DxDataGrid
                      ref="dataGridRefKey"
                      :data-source="orctoItensData"
                      :show-borders="true"
                      :focused-row-enabled="true"
                      :keyExpr="'id'"
                      :column-auto-width="true"
                      :show-row-lines="true"
                      :allow-column-reordering="true"
                      :allow-column-resizing="true"
                      :row-alternation-enabled="true"
                      @cell-prepared="onCellPrepared"
                      @row-dbl-click="onRowDblClick"
                      @content-ready="carregouGrid"
                      @exporting="onExporting"
                    >
                      <DxRemoteOperations
                        :filtering="true"
                        :paging="true"
                        :sorting="true"
                        :summary="true"
                        :grouping="false"
                        :group-paging="false"
                      />

                      <DxColumnChooser :enabled="true" />
                      <DxColumnFixing :enabled="true" />
                      <DxFilterRow :visible="true" />

                      <DxSelection mode="multiple" />
                      <DxExport
                        :enabled="true"
                        :allow-export-selected-data="true"
                      />
                      <DxStateStoring
                        :enabled="true"
                        type="sessionStorage"
                        storage-key="strWmsOsEntradaList"
                      />

                      <DxGroupPanel :visible="true" />
                      <DxGrouping />

                      <DxColumn
                          data-field="sequenc"
                          caption="Seq"
                          sort-order="asc"
                          data-type="text"
                          alignment="left"
                          :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                          :allowHeaderFiltering="true"
                      />

                      <DxColumn
                        data-field="produto"
                        caption="Produto"
                        data-type="text"
                        alignment="left"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="true"
                      />

                      <DxColumn
                        data-field="descprod"
                        caption="Descrição"
                        data-type="text"
                        alignment="left"
                        :filter-operations="[
                          'contains',
                          'notcontains',
                          'startswith',
                          'endswith',
                          '=',
                          '<>',
                        ]"
                        :allow-sorting="false"
                        :allowHeaderFiltering="true"
                      />

                      <DxColumn
                          :width="110"
                          data-field="qtd"
                          caption="Quantidade"
                          alignment="right"
                          :format="formatDecimal"
                          :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                          :allowHeaderFiltering="false"
                      />

                      <DxColumn
                        data-field="lote"
                        caption="Lote(s)"
                        data-type="text"
                        alignment="center"
                        :filter-operations="[
                          'contains',
                          'notcontains',
                          'startswith',
                          'endswith',
                          '=',
                          '<>',
                        ]"
                        :allow-sorting="false"
                        :allowHeaderFiltering="true"
                      />

                      <DxColumn
                          data-field="desconsidsaldo"
                          caption="Desconsiderar saldo"
                          data-type="text"
                          alignment="left"
                          :customize-text="formatBoolean"
                          :filter-operations="[
                          'contains',
                          'notcontains',
                          'startswith',
                          'endswith',
                          '=',
                          '<>',
                        ]"
                          :allow-sorting="false"
                          :allowHeaderFiltering="true"
                      />

                      <DxColumn
                          data-field="und"
                          caption="Unidade"
                          data-type="text"
                          alignment="center"
                          :filter-operations="[
                          'contains',
                          'notcontains',
                          'startswith',
                          'endswith',
                          '=',
                          '<>',
                        ]"
                          :allow-sorting="false"
                          :allowHeaderFiltering="true"
                      />

                      <DxColumn
                        :width="110"
                        data-field="vlrunitbrt"
                        caption="Valor Unit. (R$)"
                        alignment="right"
                        :format="formatDecimal"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                      />

                      <DxColumn
                        :width="110"
                        data-field="pesobrttot"
                        caption="Peso Total (Kg)"
                        alignment="right"
                        :format="formatDecimal"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                      />

                      <DxColumn
                        :width="110"
                        data-field="cubtot"
                        caption="Cubagem Total (m3)"
                        alignment="right"
                        :format="formatBigDecimal"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                      />

                      <DxColumn
                        :width="110"
                        data-field="conferidoqtd"
                        caption="Conferido"
                        alignment="right"
                        :format="formatDecimal"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                      />

                      <DxColumn
                        :width="110"
                        data-field="aconferirqtd"
                        caption="Saldo"
                        alignment="right"
                        :format="formatDecimal"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                      />

                      <DxColumn
                        :width="110"
                        data-field="margem"
                        caption="Margem (%)"
                        alignment="right"
                        :format="formatDecimal"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                      />

                      <DxColumn
                        :width="110"
                        data-field="desconto"
                        caption="Desconto Unit. (R$)"
                        alignment="right"
                        :format="formatDecimal"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                      />

                      <DxColumn
                        :width="110"
                        data-field="vlrtotalliq"
                        caption="Total Liq. (R$)"
                        alignment="right"
                        :format="formatDecimal"
                        :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                        :allowHeaderFiltering="false"
                      />

                      <DxColumn
                          data-field="ncm"
                          caption="NCM"
                          data-type="text"
                          alignment="center"
                          :filter-operations="[
                          'contains',
                          'notcontains',
                          'startswith',
                          'endswith',
                          '=',
                          '<>',
                        ]"
                          :allow-sorting="false"
                          :allowHeaderFiltering="true"
                      />

                      <DxColumn
                          data-field="codbarras"
                          caption="Código de barras"
                          data-type="text"
                          alignment="center"
                          :filter-operations="[
                          'contains',
                          'notcontains',
                          'startswith',
                          'endswith',
                          '=',
                          '<>',
                        ]"
                          :allow-sorting="false"
                          :allowHeaderFiltering="true"
                      />

                      <DxColumn
                          data-field="coddun14"
                          caption="Dun-14"
                          data-type="text"
                          :visible="true"
                      />

                      <DxPager
                        :visible="true"
                        :show-page-size-selector="true"
                        :allowed-page-sizes="[10, 30, 50, 100]"
                        :show-navigation-buttons="true"
                        :show-info="true"
                      />
                    </DxDataGrid>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="currentTab === 'SaldosConferencia'">
              <div class="row">
                <div class="card-body">
                  <template v-if="wmsositens.length > 0">
                    <div class="card">
                      <div>
                        <DxToolbar>
                          <DxItem location="before" widget="dxButton">
                            <DxButton
                              icon="refresh"
                              hint="Redefinir formatação de tabela para padrão"
                              :on-click="refeFormTable"
                            />
                          </DxItem>
                        </DxToolbar>
                      </div>

                      <Loader v-if="updating" style="min-height: 300px">
                      </Loader>

                      <div class="mt-2" v-if="!updating">
                        <DxDataGrid
                          ref="dataGridRefKey"
                          :data-source="wmsositens"
                          :show-borders="true"
                          :focused-row-enabled="true"
                          :keyExpr="'produto_id'"
                          :column-auto-width="true"
                          :show-row-lines="true"
                          :allow-column-reordering="true"
                          :allow-column-resizing="true"
                          :row-alternation-enabled="true"
                          @cell-prepared="onCellPrepared"
                          @row-dbl-click="onRowDblClick"
                          @content-ready="carregouGrid"
                          @exporting="onExporting"
                        >
                          <DxRemoteOperations
                            :filtering="true"
                            :paging="true"
                            :sorting="true"
                            :summary="true"
                            :grouping="false"
                            :group-paging="false"
                          />

                          <DxColumnChooser :enabled="true" />
                          <DxColumnFixing :enabled="true" />
                          <DxFilterRow :visible="true" />

                          <DxSelection mode="multiple" />
                          <DxExport
                            :enabled="true"
                            :allow-export-selected-data="true"
                          />
                          <DxStateStoring
                            :enabled="true"
                            type="sessionStorage"
                            storage-key="strWmsOsEntradaList"
                          />

                          <DxGroupPanel :visible="true" />
                          <DxGrouping />

                          <DxColumn
                            data-field="wmsos_id"
                            caption="WmsOs ID"
                            sort-order="desc"
                            data-type="number"
                            alignment="left"
                            :filter-operations="[
                              '=',
                              '<>',
                              '<',
                              '>',
                              '<=',
                              '>=',
                            ]"
                            :allowHeaderFiltering="true"
                          />

                          <DxColumn
                            data-field="produto"
                            caption="Produto"
                            sort-order="desc"
                            data-type="number"
                            alignment="center"
                            :filter-operations="[
                              '=',
                              '<>',
                              '<',
                              '>',
                              '<=',
                              '>=',
                            ]"
                            :allowHeaderFiltering="true"
                          />

                          <DxColumn
                            data-field="descprod"
                            caption="Descrição"
                            data-type="text"
                            alignment="left"
                            :filter-operations="[
                              'contains',
                              'notcontains',
                              'startswith',
                              'endswith',
                              '=',
                              '<>',
                            ]"
                            :allow-sorting="false"
                            :allowHeaderFiltering="true"
                          />

                          <DxColumn
                            :width="110"
                            data-field="und"
                            caption="Valor Unit. (R$)"
                            alignment="right"
                            :format="formatDecimal"
                            :filter-operations="[
                              '=',
                              '<>',
                              '<',
                              '>',
                              '<=',
                              '>=',
                            ]"
                            :allowHeaderFiltering="false"
                          />

                          <DxColumn
                            :width="110"
                            data-field="qtd"
                            caption="Total Itens"
                            alignment="center"
                            :format="formatDecimal"
                            :filter-operations="[
                              '=',
                              '<>',
                              '<',
                              '>',
                              '<=',
                              '>=',
                            ]"
                            :allowHeaderFiltering="false"
                          />

                          <DxColumn
                            :width="110"
                            data-field="qtdlida"
                            caption="Conferidos"
                            alignment="right"
                            :format="formatDecimal"
                            :filter-operations="[
                              '=',
                              '<>',
                              '<',
                              '>',
                              '<=',
                              '>=',
                            ]"
                            :allowHeaderFiltering="false"
                          />

                          <DxColumn
                            :width="110"
                            data-field="qtddisp"
                            caption="Pendentes"
                            alignment="right"
                            :format="formatDecimal"
                            :filter-operations="[
                              '=',
                              '<>',
                              '<',
                              '>',
                              '<=',
                              '>=',
                            ]"
                            :allowHeaderFiltering="false"
                          />

                          <DxColumn
                            data-field="updated_by"
                            caption="User"
                            data-type="text"
                            alignment="right"
                            :filter-operations="[
                              'contains',
                              'notcontains',
                              'startswith',
                              'endswith',
                              '=',
                              '<>',
                            ]"
                            :allow-sorting="false"
                            :allowHeaderFiltering="true"
                          />

                          <DxPager
                            :visible="true"
                            :show-page-size-selector="true"
                            :allowed-page-sizes="[10, 30, 50, 100]"
                            :show-navigation-buttons="true"
                            :show-info="true"
                          />
                        </DxDataGrid>
                      </div>

                      <!--                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th>WmsOs Id</th>
                          <th>Produto ({{ wmsositens.length > 0 ? wmsositens.length : 0 }})</th>
                          <th class="text-center">Nome</th>
                          <th class="text-center">Unidade</th>
                          <th class="text-center">Total itens</th>
                          <th class="text-center">Conferidos</th>
                          <th class="text-center">Pendentes</th>
                          <th class="text-center">user</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="wmsositem in wmsositens" :key="wmsositem.produto_id">
                          <td class="text-start">{{ wmsositem.wmsos_id }}</td>
                          <td class="text-start">{{ wmsositem.produto }}</td>
                          <td class="text-end">{{ wmsositem.descprod }}</td>
                          <td class="text-end">{{ wmsositem.und }}</td>
                          <td class="text-end">{{ wmsositem.qtd }}</td>
                          <td class="text-end">{{ wmsositem.qtdlida }}</td>
                          <td class="text-end">{{ wmsositem.qtddisp }}</td>
                          <td class="text-end">{{ wmsositem.updated_by ?? '-' }}</td>
                        </tr>
                        </tbody>
                      </table>-->
                    </div>
                  </template>
                  <template v-else>
                    <b-alert variant="warning" show>
                      <h4 class="alert-heading">Tudo certo por aqui!</h4>
                      <p>
                        Nenhuma conferência atrelada à esse orçamento foi
                        realizada!
                      </p>
                    </b-alert>
                  </template>
                </div>
              </div>
            </div>
            <div v-if="currentTab === 'OSRelacionadas'">
              <div class="row">
                <div class="card-body">
                  <template v-if="wmsos.length > 0">
                    <div class="card">
                      <div>
                        <DxToolbar>
                          <DxItem location="before" widget="dxButton">
                            <DxButton
                              icon="refresh"
                              hint="Redefinir formatação de tabela para padrão"
                              :on-click="refeFormTable"
                            />
                          </DxItem>
                        </DxToolbar>
                      </div>

                      <Loader v-if="updating" style="min-height: 300px">
                      </Loader>

                      <div class="mt-2" v-if="!updating">
                        <DxDataGrid
                          ref="dataGridRefKey"
                          :data-source="wmsos"
                          :show-borders="true"
                          :focused-row-enabled="true"
                          :keyExpr="'id'"
                          :column-auto-width="true"
                          :show-row-lines="true"
                          :allow-column-reordering="true"
                          :allow-column-resizing="true"
                          :row-alternation-enabled="true"
                          @cell-prepared="onCellPrepared"
                          @row-dbl-click="onRowDblClick"
                          @content-ready="carregouGrid"
                          @exporting="onExporting"
                        >
                          <DxRemoteOperations
                            :filtering="true"
                            :paging="true"
                            :sorting="true"
                            :summary="true"
                            :grouping="false"
                            :group-paging="false"
                          />

                          <DxColumnChooser :enabled="true" />
                          <DxColumnFixing :enabled="true" />
                          <DxFilterRow :visible="true" />

                          <DxSelection mode="multiple" />
                          <DxExport
                            :enabled="true"
                            :allow-export-selected-data="true"
                          />
                          <DxStateStoring
                            :enabled="true"
                            type="sessionStorage"
                            storage-key="strWmsOsEntradaList"
                          />

                          <DxGroupPanel :visible="true" />
                          <DxGrouping />

                          <DxColumn
                            data-field="id"
                            caption="WmsOs ID"
                            sort-order="desc"
                            data-type="number"
                            alignment="left"
                            :filter-operations="[
                              '=',
                              '<>',
                              '<',
                              '>',
                              '<=',
                              '>=',
                            ]"
                            :allowHeaderFiltering="true"
                          />

                          <DxColumn
                            data-field="status"
                            caption="Status"
                            data-type="text"
                            alignment="center"
                            :filter-operations="[
                              'contains',
                              'notcontains',
                              'startswith',
                              'endswith',
                              '=',
                              '<>',
                            ]"
                            :allow-sorting="false"
                            :allowHeaderFiltering="true"
                          />

                          <DxColumn
                            data-field="created_at_formatted"
                            caption="Data de Criação"
                            alignment="right"
                            data-type="datetime"
                            format="dd/MM/yyyy"
                            :filter-operations="[
                              '=',
                              '<>',
                              '<',
                              '>',
                              '<=',
                              '>=',
                            ]"
                            :allowHeaderFiltering="true"
                          />

                          <DxColumn
                            data-field="created_by"
                            caption="Iniciado por"
                            data-type="text"
                            alignment="center"
                            :filter-operations="[
                              'contains',
                              'notcontains',
                              'startswith',
                              'endswith',
                              '=',
                              '<>',
                            ]"
                            :allow-sorting="false"
                            :allowHeaderFiltering="true"
                          />

                          <DxColumn
                            data-field="updated_at_formatted"
                            caption="Última Atualização"
                            alignment="right"
                            data-type="datetime"
                            format="dd/MM/yyyy"
                            :filter-operations="[
                              '=',
                              '<>',
                              '<',
                              '>',
                              '<=',
                              '>=',
                            ]"
                            :allowHeaderFiltering="true"
                          />

                          <DxColumn
                            data-field="updated_by"
                            caption="Atualizado por"
                            data-type="text"
                            alignment="left"
                            :filter-operations="[
                              'contains',
                              'notcontains',
                              'startswith',
                              'endswith',
                              '=',
                              '<>',
                            ]"
                            :allow-sorting="false"
                            :allowHeaderFiltering="true"
                          />

                          <DxPager
                            :visible="true"
                            :show-page-size-selector="true"
                            :allowed-page-sizes="[10, 30, 50, 100]"
                            :show-navigation-buttons="true"
                            :show-info="true"
                          />
                        </DxDataGrid>
                      </div>

                      <!--                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th>WmsOs ({{ wmsos.length > 0 ? wmsos.length : 0 }})</th>
                          <th class="text-center">Status</th>
                          <th class="text-center">Data criação</th>
                          <th class="text-center">Iniciado por</th>
                          <th class="text-center">Última atualização</th>
                          <th class="text-center">Atualizador por</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="os in wmsos" :key="os.id">
                          <h5 class="font-size-14 text-truncate">
                            <a href="javascript: void(0);" class="text-body fw-bold text-wrap"
                               @click="redirecionaPedido(os.id)">
                              {{ os.id }}
                            </a>
                          </h5>
                          <td class="text-start">{{ os.status }}</td>
                          <td class="text-end">{{ os.created_at_formatted }}</td>
                          <td class="text-end">{{ os.created_by }}</td>
                          <td class="text-end">{{ os.updated_at_formatted }}</td>
                          <td class="text-end">{{ os.updated_by ?? '-' }}</td>
                        </tr>
                        </tbody>
                      </table>-->
                    </div>
                  </template>
                  <template v-else>
                    <b-alert variant="warning" show>
                      <h4 class="alert-heading">Tudo certo por aqui!</h4>
                      <p>Não existe nenhum pedido atrelado à esse orçamento!</p>
                    </b-alert>
                  </template>
                </div>
              </div>
            </div>

            <!--            <div>
              <DxToolbar>

                <DxItem
                    location="before"
                    widget="dxButton">
                  <DxButton
                      icon="refresh"
                      hint="Redefinir formatação de tabela para padrão"
                      :on-click="refeFormTable"/>
                </DxItem>

              </DxToolbar>
            </div>

            <Loader v-if="updating" style="min-height: 300px;">
            </Loader>

            <div class="mt-2" v-if="!updating">
              <DxDataGrid
                  ref="dataGridRefKey"
                  :data-source="orctoItensData"
                  :show-borders="true"
                  :focused-row-enabled="true"
                  :keyExpr="'id'"
                  :column-auto-width="true"
                  :show-row-lines="true"
                  :allow-column-reordering="true"
                  :allow-column-resizing="true"
                  :row-alternation-enabled="true"
                  @cell-prepared="onCellPrepared"
                  @row-dbl-click="onRowDblClick"
                  @content-ready="carregouGrid"
                  @exporting="onExporting">

                <DxRemoteOperations
                    :filtering="true"
                    :paging="true"
                    :sorting="true"
                    :summary="true"
                    :grouping="false"
                    :group-paging="false"
                />


                <DxColumnChooser :enabled="true"/>
                <DxColumnFixing :enabled="true"/>
                <DxFilterRow :visible="true"/>


                <DxSelection mode="multiple"/>
                <DxExport
                    :enabled="true"
                    :allow-export-selected-data="true"/>
                <DxStateStoring
                    :enabled="true"
                    type="sessionStorage"
                    storage-key="strWmsOsEntradaList"/>

                <DxGroupPanel :visible="true"/>
                <DxGrouping/>

                <DxColumn
                    data-field="produto"
                    caption="Produto"
                    sort-order="desc"
                    data-type="number"
                    alignment="center"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="true"/>

                <DxColumn
                    data-field="descprod"
                    caption="Descrição"
                    data-type="text"
                    alignment="center"
                    :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                    :allow-sorting="false"
                    :allowHeaderFiltering="true"/>

                <DxColumn
                    :width="110"
                    data-field="vlrunitbrt"
                    caption="Valor Unit. (R$)"
                    alignment="center"
                    :format="formatDecimal"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"/>

                <DxColumn
                    :width="110"
                    data-field="pesobrttot"
                    caption="Peso Total (Kg)"
                    alignment="center"
                    :format="formatDecimal"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"/>

                <DxColumn
                    :width="110"
                    data-field="cubtot"
                    caption="Cubagem Total (m3)"
                    alignment="center"
                    :format="formatDecimal"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"/>

                <DxColumn
                    :width="110"
                    data-field="qtd"
                    caption="Quantidade"
                    alignment="center"
                    :format="formatDecimal"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"/>

                 <DxColumn
                    :width="110"
                    data-field="conferidoqtd"
                    caption="Conferido"
                    alignment="center"
                    :format="formatDecimal"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"/>

                 <DxColumn
                    :width="110"
                    data-field="aconferirqtd"
                    caption="A Conferir"
                    alignment="center"
                    :format="formatDecimal"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"/>

                <DxColumn
                    :width="110"
                    data-field="margem"
                    caption="Margem (%)"
                    alignment="center"
                    :format="formatDecimal"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"/>

                <DxColumn
                    :width="110"
                    data-field="desconto"
                    caption="Desconto Unit. (R$)"
                    alignment="center"
                    :format="formatDecimal"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"/>

                <DxColumn
                    :width="110"
                    data-field="vlrtotalliq"
                    caption="Total Liq. (R$)"
                    alignment="center"
                    :format="formatDecimal"
                    :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                    :allowHeaderFiltering="false"/>

                <DxPager
                    :visible="true"
                    :show-page-size-selector="true"
                    :allowed-page-sizes="[10, 30, 50, 100]"
                    :show-navigation-buttons="true"
                    :show-info="true"/>

              </DxDataGrid>
            </div>-->
          </div>
        </div>
      </div>
    </div>

    <b-modal
      size="md"
      :title="Prod != null ? `Ações -  (Prod.: ${Prod}) ` : 'Ações'"
      v-model="showModalAcao"
      centered
      hide-footer
    >
      <div class="d-flex col-10 justify-content-between mt-2 mb-2">
        <b-button
          variant="outline-success"
          class="action-icon text-success mx-2"
          @click="detalhesProduto(idProd)"
        >
          <i class="mdi mdi-eye font-size-18"></i>
          Detalhes
        </b-button>

        <b-button
          variant="outline-warning"
          v-if="
            paramOrctoConfParcFin === true
              ? orctoData.status === 'EL'
              : orctoData.status === 'EL' || orctoData.status === 'CP'
          "
          class="action-icon text-warning mx-2"
          @click="editarProduto(idRow)"
        >
          <i class="mdi mdi-pencil-outline font-size-18"></i>
          Editar
        </b-button>

        <b-button
          variant="outline-danger"
          v-if="
            paramOrctoConfParcFin === true
              ? orctoData.status === 'EL'
              : orctoData.status === 'EL' || orctoData.status === 'CP'
          "
          class="action-icon text-danger mx-2"
          @click="deletarOrctoItem(idRow)"
        >
          <i class="mdi mdi-trash-can font-size-18"></i>
          Deletar
        </b-button>
      </div>
    </b-modal>

    <b-modal
      size="lg"
      :title="
        clienteData != null
          ? `Detalhes Cliente (${clienteData.nome})`
          : 'Detalhes Cliente'
      "
      v-model="showModalCliente"
      centered
      hide-footer
    >
      <div class="col-md-12">
        <div class="mb-3">
          <span>Selecionar Novo Cliente</span>

          <multiselect
            id="inputCliente"
            @search-change="pesqCliente"
            @select="escolheuCli"
            v-model="orctoData.cliente"
            placeholder="Pesquisar cliente"
            :options="dtListPesqCli"
            :searchable="true"
            label="nome"
            track-by="nome"
            value-prop="codigo"
          >
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4">
                    {{ slotProps.option.cnpj }}
                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                <div class="align-items-end text-end align-content-end">
                  {{ slotProps.option.cidade }} - {{ slotProps.option.estado }}
                </div>
              </div>
            </template>
          </multiselect>
        </div>
      </div>

      <div class="row" v-if="loadingCliente">
        <div class="col-12 text-center">
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingCliente && clienteData">
        <router-link :to="`/cliente/detalhe/${clienteData.id}`" target="_blank">
          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ clienteData.codigo }} </span>
          </p>
        </router-link>
        <p class="mb-2" v-if="orctoData.cliender === 1">
          <span class="text-muted"> Entregar: </span>
          <span>
            {{ clienteData.rua }}, {{ clienteData.numero }},
            {{ clienteData.bairro }}
          </span>
          <span> | </span>
          <span> {{ clienteData.cidade }} - {{ clienteData.estado }} </span>
        </p>

        <p class="mb-2" v-if="orctoData.cliender === 2">
          <span class="text-muted"> Entregar: </span>
          <span>
            {{ pessoaEnderData.rua1 }}, {{ pessoaEnderData.numero1 }},
            {{ pessoaEnderData.bairro1 }}
          </span>
          <span> | </span>
          <span>
            {{ pessoaEnderData.cidade1 }} - {{ pessoaEnderData.estado1 }}
          </span>
        </p>

        <p class="mb-2" v-if="orctoData.cliender === 3">
          <span class="text-muted"> Entregar: </span>
          <span>
            {{ pessoaEnderData.rua2 }}, {{ pessoaEnderData.numero2 }},
            {{ pessoaEnderData.bairro2 }}
          </span>
          <span> | </span>
          <span>
            {{ pessoaEnderData.cidade2 }} - {{ pessoaEnderData.estado2 }}
          </span>
        </p>

        <p class="mb-4"></p>

        <p class="mb-4">
          <span> {{ clienteData.tel1 }} / {{ clienteData.email }}</span>
        </p>
        <div class="table-responsive">
          <table class="table table-centered table-nowrap">
            <thead>
              <tr>
                <th scope="col">Últimos Pedidos</th>
                <th scope="col" class="text-end">Data</th>
                <th scope="col" class="text-end">Valor (R$)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="data in ultPedsData" :key="data.id">
                <td>
                  <router-link
                    :to="`/orcamento/editar/${data.id}`"
                    target="_blank"
                  >
                    <div>
                      <h5 class="text-truncate font-size-14">
                        {{ data.codigo }}
                      </h5>
                    </div>
                  </router-link>
                </td>
                <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
                <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
              </tr>
              <tr>
                <td colspan="2">
                  <h6 class="m-0 text-end">Valor Total Pedidos:</h6>
                </td>
                <td class="text-end">R$ {{ formatDecimal(somaPedidosCli) }}</td>
              </tr>
              <tr>
                <td colspan="2">
                  <h6 class="m-0 font-size-14 text-end">Ticket Médio:</h6>
                </td>
                <td class="font-size-14 text-end">
                  R$ {{ formatDecimal(somaPedidosCli / 3) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-if="clienteData && showSelecionarEnder">
        <div class="mb-2">
          <label>Selecionar Endereço de Entrega:</label>

          <div class="row">
            <div class="col-xl-4 col-sm-4">
              <div class="mb-3">
                <label class="card-radio-label mb-2">
                  <input
                    type="radio"
                    v-model="orctoData.cliender"
                    :value="1"
                    name="currency"
                    id="buycurrencyoption1"
                    class="card-radio-input"
                    checked
                  />
                  <div class="card-radio">
                    <div>
                      <i
                        class="mdi mdi-office-building-marker-outline font-size-24 text-warning align-middle me-2"
                      ></i>
                      <span
                        >{{ clienteData.cidade }} -
                        {{ clienteData.estado }}</span
                      >
                    </div>
                  </div>
                </label>

                <div>
                  <p class="text-muted mb-1 text-wrap">
                    {{ clienteData.rua }}, {{ clienteData.numero }}
                  </p>
                  <h5 class="font-size-16">
                    {{ clienteData.bairro }} - {{ clienteData.cep }}
                  </h5>
                </div>
              </div>
            </div>

            <div class="col-xl-4 col-sm-4" v-if="pessoaEnderData">
              <div class="mb-3">
                <label class="card-radio-label mb-2">
                  <input
                    type="radio"
                    v-model="orctoData.cliender"
                    :value="2"
                    name="currency"
                    id="buycurrencyoption2"
                    class="card-radio-input"
                  />
                  <div class="card-radio">
                    <div>
                      <i
                        class="mdi mdi-office-building-marker-outline font-size-24 text-primary align-middle me-2"
                      ></i>
                      <span
                        >{{ pessoaEnderData.cidade1 }} -
                        {{ pessoaEnderData.estado1 }}</span
                      >
                    </div>
                  </div>
                </label>
                <div>
                  <p class="text-muted mb-1">
                    {{ pessoaEnderData.rua1 }}, {{ pessoaEnderData.numero1 }}
                  </p>
                  <h5 class="font-size-16">
                    {{ pessoaEnderData.bairro1 }} - {{ pessoaEnderData.cep1 }}
                  </h5>
                </div>
              </div>
            </div>

            <div
              class="col-xl-4 col-sm-4"
              v-if="pessoaEnderData && pessoaEnderData.cidade2"
            >
              <div class="mb-3">
                <label class="card-radio-label mb-2">
                  <input
                    type="radio"
                    v-model="orctoData.cliender"
                    :value="3"
                    name="currency"
                    id="buycurrencyoption3"
                    class="card-radio-input"
                  />

                  <div class="card-radio">
                    <div>
                      <i
                        class="mdi mdi-home font-size-24 text-info align-middle me-2"
                      ></i>
                      <span
                        >{{ pessoaEnderData.cidade2 }} -
                        {{ pessoaEnderData.estado2 }}</span
                      >
                    </div>
                  </div>
                </label>

                <div>
                  <p class="text-muted mb-1">
                    {{ pessoaEnderData.rua2 }}, {{ pessoaEnderData.numero2 }}
                  </p>
                  <h5 class="font-size-16">
                    {{ pessoaEnderData.bairro2 }} - {{ pessoaEnderData.cep2 }}
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="text-start mt-5">
          <a
            href="javascript: void(0);"
            @click="showSelecionarEnder = !showSelecionarEnder"
          >
            <i class="bx bx-pencil font-size-16 align-middle me-2"></i>
            Alterar Endereço de Entrega
          </a>
        </div>
      </div>

      <div>
        <div class="text-start mt-3">
          <router-link to="/cliente/editar/0" target="_blank">
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            Cadastrar Novo Cliente
          </router-link>
        </div>
      </div>

      <div v-if="!loadingCliente && clienteData">
        <div class="text-end mt-0">
          <b-button variant="light" @click="showModalCliente = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button
            type="submit"
            variant="success"
            class="ms-1"
            @click="confirmarCliente"
          >
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      title="Detalhes Tipo de operação"
      v-model="showModalPedTipo"
      centered
      hide-footer
    >
      <div class="col-md-12">
        <div class="mb-3">
          <span>Selecionar Novo Tipo de Operação</span>

          <multiselect
            id="tipooperacao"
            @search-change="pesqPedTipo"
            @select="escolheuPedTipo"
            v-model="orctoData.tipo"
            placeholder="Pesquisar tipo de operação"
            :options="dtlistPesqPedTipo"
            :searchable="true"
            label="descricao"
            track-by="descricao"
            value-prop="codigo"
          >
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4"> </span>
                </div>
                <div class="mt-2 font-size-20">
                  {{ slotProps.option.descricao }}
                </div>
                <span class="mx-4"> </span>
                <div class="align-items-end text-end align-content-end">
                  {{ formatDateTime(slotProps.option.created_at) }}
                </div>
              </div>
            </template>
          </multiselect>
        </div>
      </div>

      <div class="row" v-if="loadingPedTipo">
        <div class="col-12 text-center">
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingPedTipo && pedTipoData">
        <p class="mb-2">Tipo de Operação Atual</p>
        <router-link :to="`/tiposopera/list`" target="_blank">
          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ pedTipoData.codigo }} </span>
          </p>

          <p class="mb-2">
            Descrição:
            <span class="text-primary"> {{ pedTipoData.descricao }} </span>
          </p>
        </router-link>

        <div class="table-responsive" v-if="ultPedsData">
          <table class="table table-centered table-nowrap">
            <thead>
              <tr>
                <th scope="col">Últimos Pedidos</th>
                <th scope="col" class="text-end">Data</th>
                <th scope="col" class="text-end">Valor (R$)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="data in ultPedsData" :key="data.id">
                <td>
                  <router-link
                    :to="`/orcamento/editar/${data.id}`"
                    target="_blank"
                  >
                    <div>
                      <h5 class="text-truncate font-size-14">
                        {{ data.codigo }}
                      </h5>
                    </div>
                  </router-link>
                </td>
                <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
                <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
              </tr>
              <tr>
                <td colspan="2">
                  <h6 class="m-0 text-end">Valor Total Pedidos:</h6>
                </td>
                <td class="text-end">R$ {{ formatDecimal(somaPedidosCli) }}</td>
              </tr>
              <tr>
                <td colspan="2">
                  <h6 class="m-0 font-size-14 text-end">Ticket Médio:</h6>
                </td>
                <td class="font-size-14 text-end">
                  R$ {{ formatDecimal(somaPedidosCli / 3) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalPedTipo = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button
            type="submit"
            variant="success"
            class="ms-1"
            @click="confirmarPedTipo"
          >
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal title="Detalhes Natureza operação" v-model="showModalNatureza" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <span>Selecionar Natureza da Operação</span>

          <multiselect
            id="tiponatureza"
            @search-change="pesqNatureza"
            @click="escolheuNatureza"
            v-model="orctoData.tipo"
            placeholder="Pesquisar Natureza da operação"
            :options="dtlistPesqNatureza"
            :searchable="true"
            label="descricao"
            track-by="descricao"
            value-prop="id">

            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-muted font-size-14">
                    CFOP: {{ slotProps.option.cfopicms ?? 'Sem Cadastrado!' }}
                  </span>
                </div>

                <span class="mx-4"></span>

                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>

                <span class="mx-4"></span>

                <div class="align-items-end text-end align-content-end">
                  {{ formatDateTime(slotProps.option.created_at) }}
                </div>
              </div>
            </template>
          </multiselect>
        </div>
      </div>

      <div class="row" v-if="loadingPedTipo">
        <div class="col-12 text-center">
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
        </div>
      </div>

      <div class="text-end mt-5">
          <b-button variant="light" @click="showModalNatureza = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button
            variant="success"
            class="ms-1"
            @click="showModalNatureza = false"
          >
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
    </b-modal>

    <b-modal title="Editar Dados Financeiros" v-model="showModalFinanceiroData" centered hide-footer>
      <div class="row mt-3">
        <div class="col-md-6">
          <div class="mb-3">
            <label for="condpgto">Condição de Pagamento</label>
            <multiselect id="condpgto"
                         @search-change="pesqCondPgto"
                         @select="escolheuCondPgto"
                         v-model="orctoData.condpgto"
                         placeholder="Pesquisar condição de pagamento"
                         :options="dtListPesqCondPgto"
                         :searchable="true"
                         label="descricao"
                         class="multiselect-size"
                         track-by="codigo"
                         value-prop="codigo">
              <template #option="slotProps">
                <div class="row">
                  <div>
                    <span class="text-info">
                      {{ slotProps.option.codigo }}
                    </span>
                    <span class="ms-2" >
                      {{ slotProps.option.descricao }}
                    </span>
                  </div>
                </div>
              </template>
            </multiselect>
          </div>
        </div>


        <div class="col-md-6">
          <div class="mb-3">
            <label for="formapgto">Forma de Pagamento</label>
            <multiselect id="formapgto"
                         @search-change="pesqFormaPgto"
                         @select="escolheuFormaPgto"
                         v-model="orctoData.formapgto"
                         placeholder="Pesquisar forma de pagamento"
                         :options="dtListPesqFormaPgto"
                         :searchable="true"
                         label="descricao"
                         class="multiselect-size"
                         track-by="codigo"
                         value-prop="codigo">
              <template #option="slotProps">
                <div class="row">
                  <div>
                    <span class="text-info">
                      {{ slotProps.option.codigo }}
                    </span>
                    <span class="ms-2" >
                      {{ slotProps.option.descricao }}
                    </span>
                  </div>
                </div>
              </template>
            </multiselect>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="banco">Instituição bancária</label>
            <multiselect id="inputFinConta"
                         @search-change="pesqConta"
                         @select="escolheuConta"
                         v-model="financeiroData.banco_id"
                         placeholder="Selecione a Inst. Bancária"
                         :options="dtListPesqConta"
                         :searchable="true"
                         label="descricao"
                         class="multiselect-size"
                         track-by="id"
                         value-prop="id">
              <template #option="slotProps">
                <div class="row">
                  <div>
                    <span class="text-info">
                      {{ slotProps.option.id }}
                    </span>
                    <span class="font-size-10 mx-1 me-4">
                       (banco: {{ slotProps.option.banco }})
                    </span>
                    <span class="" >
                      {{ slotProps.option.descricao }}
                    </span>
                  </div>
                </div>
              </template>
            </multiselect>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <div class="mb-4 align-items-end align-content-start float-start mx-4">
              <label for="consutil">Considerar apenas dias úteis</label>
              <b-form-checkbox switch size="lg" v-model="financeiroData.consutil">
                {{ financeiroData.consutil === false ? 'Desativado' : 'Ativado' }}
              </b-form-checkbox>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="loadingFinanc">
        <div class="col-12 text-center">
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingFinanc && financeiroData">
        <div class="row mt-4">
          <h6 class="mb-2 col-md-12">Condição de Pagamento Atual:</h6>

          <div class="col-md-6">
            <p class="mb-2">
              Cond. Pgto:
              <span class="text-primary"> {{ financeiroData.condpgto }} </span>
            </p>

            <p class="mb-2">
              Forma Pgto:
              <span class="text-primary"> {{ financeiroData.formapgto }} </span>
            </p>
          </div>

          <div class="col-md-6">
            <p class="mb-2">
              Banco:
              <span class="text-primary"> {{ financeiroData.banco }} </span>
            </p>

            <p class="mb-2">
              Cons. dia útel:
              <span class="text-primary"> {{ financeiroData.consutil }} </span>
            </p>
          </div>

        </div>




        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalFinanceiroData = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarFinanceiro">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>

    <b-modal
      size="lg"
      title="Alterar Observações"
      v-model="showModalObs"
      centered
      hide-footer
    >
      <div class="col-md-12">
        <div class="mb-3">
          <label for="obs">Observações do Pedido</label>
          <textarea
            id="obs"
            v-model="orctoData.obs"
            type="text"
            rows="3"
            class="form-control"
            placeholder="Observações do Pedido"
          />
        </div>

        <div class="mb-3">
          <label for="obsnf">Observações da Nota Fiscal</label>
          <textarea
            id="obsnf"
            v-model="orctoData.obsnf"
            type="text"
            rows="3"
            class="form-control"
            placeholder="Observações da Nota Fiscal"
          />
        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalObs = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button
            type="submit"
            variant="success"
            class="ms-1"
            @click="showModalObs = false"
          >
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      title="Alterar Valor de Frete"
      v-model="showModalFrete"
      centered
      hide-footer
    >
      <div class="col-md-12">
        <div class="mb-3">
          <label for="valorfrt">Favor informar o valor do frete</label>
          <input
            id="valorfrt"
            v-model="orctoData.valorfrt"
            type="number"
            class="form-control"
            placeholder="Valor do frete (R$)"
          />
        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalFrete = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button
            type="submit"
            variant="success"
            class="ms-1"
            @click="confirmarFrete"
          >
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      title="Alterar Porcentagem de Desconto"
      v-model="showModalDesconto"
      centered
      hide-footer
    >
      <div class="col-md-12">
        <div class="mb-3">
          <label for="percdesc"
            >Favor informar a nova porcentagem de desconto (%)</label
          >
          <input
            id="percdesc"
            v-model="orctoData.percdesc"
            type="number"
            class="form-control"
            placeholder="Porcentagem de Desconto (%)"
          />
        </div>

        <!--        <b-alert show dismissible variant="danger" >-->
        <!--          <i class="mdi mdi-alert me-2"></i>Todos os produtos serão recalculados-->
        <!--        </b-alert>-->

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalDesconto = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button
            type="submit"
            variant="success"
            class="ms-1"
            @click="confirmarDesconto"
          >
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      title="Auditoria"
      v-model="showModalAuditoria"
      centered
      hide-footer
    >
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label for="created_by">Usuário Criação</label>
            <input
              id="created_by"
              v-model="orctoData.created_by"
              type="text"
              class="form-control"
              :disabled="true"
              placeholder="Usuário Criação"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="created_at">Criado em</label>
            <input
              id="created_at"
              v-model="orctoData.created_at"
              type="datetime-local"
              class="form-control"
              :disabled="true"
              placeholder="Criado em"
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label for="updated_by">Usuário Atualização</label>
            <input
              id="updated_by"
              v-model="orctoData.updated_by"
              type="text"
              class="form-control"
              :disabled="true"
              placeholder="Usuário Atualização"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="updated_at">Atualizado em</label>
            <input
              id="updated_at"
              v-model="orctoData.updated_at"
              type="datetime-local"
              class="form-control"
              :disabled="true"
              placeholder="Atualizado em"
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalAuditoria = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Fechar
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      title="Detalhes Representante"
      v-model="showModalRepres"
      centered
      hide-footer
    >
      <div class="col-md-12">
        <div class="mb-3">
          <span>Selecionar Novo Representante</span>

          <multiselect
            id="repres"
            @search-change="pesqRepres"
            @select="escolheuRepres"
            v-model="orctoData.repres"
            placeholder="Pesquisar representante"
            :options="dtListPesqRepres"
            :searchable="true"
            label="descricao"
            track-by="descricao"
            value-prop="codigo"
          >
            <template #option="slotProps">
              <div class="row">
                <div v-if="slotProps.option.codigo">
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4"> </span>
                </div>
                <div class="mt-2 font-size-20" v-if="slotProps.option.descricao">
                  {{ slotProps.option.descricao }}
                </div>
                <span class="mx-4"> </span>
                <span class="mx-4"> </span>
                <div class="align-items-end text-end align-content-end">
                  {{ formatDateTime(slotProps.option.created_at) }}
                </div>
              </div>
            </template>
          </multiselect>
        </div>
      </div>

      <div class="row" v-if="loadingRepres">
        <div class="col-12 text-center">
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingRepres && represData">
        <p class="mb-2">Representante Atual</p>
        <router-link :to="`/tiposopera/list`" target="_blank">
          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ represData.codigo }} </span>
          </p>

          <p class="mb-2">
            Nome:
            <span class="text-primary"> {{ represData.descricao }} </span>
          </p>
        </router-link>

        <div class="table-responsive" v-if="ultPedsData">
          <table class="table table-centered table-nowrap">
            <thead>
              <tr>
                <th scope="col">Últimos Pedidos</th>
                <th scope="col" class="text-end">Data</th>
                <th scope="col" class="text-end">Valor (R$)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="data in ultPedsData" :key="data.id">
                <td>
                  <router-link
                    :to="`/orcamento/editar/${data.id}`"
                    target="_blank"
                  >
                    <div>
                      <h5 class="text-truncate font-size-14">
                        {{ data.codigo }}
                      </h5>
                    </div>
                  </router-link>
                </td>
                <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
                <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
              </tr>
              <tr>
                <td colspan="2">
                  <h6 class="m-0 text-end">Valor Total Pedidos:</h6>
                </td>
                <td class="text-end">R$ {{ formatDecimal(somaPedidosCli) }}</td>
              </tr>
              <tr>
                <td colspan="2">
                  <h6 class="m-0 font-size-14 text-end">Ticket Médio:</h6>
                </td>
                <td class="font-size-14 text-end">
                  R$ {{ formatDecimal(somaPedidosCli / 3) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalRepres = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button
            type="submit"
            variant="success"
            class="ms-1"
            @click="confirmarRepres"
          >
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      title="Detalhes Transportadora"
      v-model="showModalTransp"
      centered
      hide-footer
    >
      <div class="col-md-12">
        <div class="mb-3">
          <span>Selecionar Nova Transportadora</span>

          <multiselect
            id="repres"
            @search-change="pesqTransp"
            @select="escolheuTransp"
            v-model="orctoData.transp"
            placeholder="Pesquisar transportadora"
            :options="dtListPesqTransp"
            :searchable="true"
            label="nome"
            track-by="nome"
            value-prop="codigo"
          >
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4"> </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                <span class="mx-4"> </span>
                <span class="mx-4"> </span>
                <div class="align-items-end text-end align-content-end">
                  {{ formatDateTime(slotProps.option.created_at) }}
                </div>
              </div>
            </template>
          </multiselect>
        </div>
      </div>

      <div class="row" v-if="loadingTransp">
        <div class="col-12 text-center">
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
        </div>
      </div>

      <div class="col-md-12">
        <div class="mb-3">
          <span>Seguimento Frete</span>

          <multiselect
            id="repres"
            @search-change="pesqFreteCota"
            @select="escolheuFreteCota"
            v-model="orctoData.segto"
            placeholder="Pesquisar seguimento"
            :options="dtListPesqFreteCota"
            :searchable="true"
            label="nome"
            track-by="nome"
            value-prop="codigo"
          >
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4"> </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                <span class="mx-4"> </span>
                <span class="mx-4"> </span>
                <div class="align-items-end text-end align-content-end">
                  {{ formatDateTime(slotProps.option.created_at) }}
                </div>
              </div>
            </template>
          </multiselect>
        </div>
      </div>

      <div v-if="!loadingTransp && transpData">
        <p class="mb-2">Transportadora Atual</p>
        <router-link :to="`/tiposopera/list`" target="_blank">
          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ transpData.codigo }} </span>
          </p>

          <p class="mb-2">
            Nome:
            <span class="text-primary"> {{ transpData.nome }} </span>
          </p>
        </router-link>

        <div class="table-responsive" v-if="ultPedsData">
          <table class="table table-centered table-nowrap">
            <thead>
              <tr>
                <th scope="col">Últimos Pedidos</th>
                <th scope="col" class="text-end">Data</th>
                <th scope="col" class="text-end">Valor (R$)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="data in ultPedsData" :key="data.id">
                <td>
                  <router-link
                    :to="`/orcamento/editar/${data.id}`"
                    target="_blank"
                  >
                    <div>
                      <h5 class="text-truncate font-size-14">
                        {{ data.codigo }}
                      </h5>
                    </div>
                  </router-link>
                </td>
                <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
                <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
              </tr>
              <tr>
                <td colspan="2">
                  <h6 class="m-0 text-end">Valor Total Pedidos:</h6>
                </td>
                <td class="text-end">R$ {{ formatDecimal(somaPedidosCli) }}</td>
              </tr>
              <tr>
                <td colspan="2">
                  <h6 class="m-0 font-size-14 text-end">Ticket Médio:</h6>
                </td>
                <td class="font-size-14 text-end">
                  R$ {{ formatDecimal(somaPedidosCli / 3) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalTransp = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button
            type="submit"
            variant="success"
            class="ms-1"
            @click="confirmarTransp"
          >
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      size="lg"
      :title="
        orctoItemData.id != null
          ? `Editar Item do Orçamento (${orctoItemData.id})`
          : 'Criar Novo Item no Orçamento'
      "
      v-model="showModalOrctoItem"
      @shown="focusProdOrctoItem"
      hide-footer
    >
      <div class="col-md-12">
        <div class="mb-3">
          <span>Selecionar Novo Produto</span>
          <multiselect
            id="prodorctoitem"
            ref="focusThis"
            @search-change="pesqOrctoItem"
            @select="escolheuOrctoItem"
            v-model="orctoItemData.produto"
            placeholder="Pesquisar novo produto"
            :options="dtlistPesqOrctoItem"
            :searchable="true"
            label="descricao"
            class="multiselect-size"
            track-by="descrcodigo"
            value-prop="codigo"
          >
            <template #option="slotProps" v-if="dtlistPesqOrctoItem">
              <div class="row" style="min-width: 100%">
                <div style="min-width: 100%">
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4">
                    {{ slotProps.option.unidade }}
                  </span>
                  <span class="float-end text-warning">
                    R$ {{ formatDecimal(slotProps.option.preco) }}
                  </span>
                </div>

                <div class="col-12">
                  <span class="mt-5 font-size-15">
                    {{ slotProps.option.descricao }}
                  </span>
                  <span class="float-end">
                    <!--                    R$ {{ formatDecimal(slotProps.option.preco) }}-->
                  </span>
                </div>
                <div
                  class="align-items-end text-end align-content-end float-end"
                >
                  <div v-if="!slotProps.option.imgSTrat" class="avatar-xs">
                    <span class="avatar-title rounded-circle">{{
                      slotProps.option.id
                    }}</span>
                  </div>
                  <div v-if="slotProps.option.imgSTrat">
                    <img
                      class="rounded-circle avatar-xs"
                      :src="slotProps.option.img1"
                      alt
                    />
                  </div>

                  <span class="float-end">
                    <span
                      v-if="slotProps.option.saldo > 0"
                      class="avatar-title rounded-circle bg-success avatar-xs p-1"
                    >
                      <span class="">{{
                        formatInteger(slotProps.option.saldo)
                      }}</span>
                    </span>

                    <span
                      v-else
                      class="avatar-title rounded-circle bg-danger avatar-xs p-1"
                    >
                      <span class="">{{
                        formatDecimal(slotProps.option.preco)
                      }}</span>
                    </span>
                  </span>
                </div>
              </div>
            </template>
          </multiselect>
        </div>
      </div>
      <div class="row" v-if="loadingOrctoItem">
        <div class="col-12 text-center">
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingOrctoItem && orctoItemData && orctoItemData.descprod">
        <router-link
          :to="`/produto/editar/${orctoItemData.produto_id}`"
          target="_blank"
        >
          <div class="row">
            <div class="col-lg-6">
              <div class="card mini-stats-wid">
                <div class="card-body" style="min-height: 160px">
                  <div class="d-flex flex-wrap">
                    <div class="me-2">
                      <p class="text-muted mb-2">
                        {{ orctoItemData.descprod }}
                      </p>
                      <h5 class="mb-0">
                        saldo: {{ formatInteger(orctoItemData.saldo) }} ({{
                          orctoItemData.und
                        }})
                      </h5>
                    </div>
                    <h1>IMG2 {{ orctoItemData.img1 }}</h1>
                    <div class="avatar-sm ms-auto">
                      <div
                        class="avatar-sm ms-auto"
                        v-if="!orctoItemData.imgSTrat"
                      >
                        <div
                          class="avatar-title bg-light rounded-circle text-primary font-size-20"
                        >
                          <i class="bx bx-camera-off"></i>
                        </div>
                      </div>

                      <div
                        class="avatar-sm ms-auto"
                        v-if="orctoItemData.imgSTrat"
                      >
                        <div
                          class="avatar-title bg-light rounded-circle text-primary font-size-20"
                        >
                          <img
                            class="rounded-circle avatar-xs"
                            :src="orctoItemData.imgSTrat"
                            alt
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="card mini-stats-wid">
                <div class="card-body" style="min-height: 155px">
                  <div class="d-flex flex-wrap">
                    <div class="me-2">
                      <span class="text-muted mb-2">Código: </span>
                      <span class="text-info">
                        {{ orctoItemData.produto }}
                      </span>
                    </div>
                    <div class="">
                      <p class="text-muted mb-2">Preço de Tabela (Bruto)</p>
                      <h5 class="mb-0 mt-3">
                        R$ {{ formatDecimal(orctoItemData.vlrunitbrt) }}
                      </h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div
                        class="avatar-title bg-light rounded-circle text-primary font-size-20"
                      >
                        <i class="bx bx-money"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </router-link>

        <form class="needs-validation" @submit.prevent="confOrctoItem">
          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="vlrunitliq">Valor Unitário</label>
                <input
                  id="vlrunitliq"
                  v-model="orctoItemData.vlrunitliq"
                  type="number"
                  class="form-control text-end"
                  placeholder="Valor unitário líquido"
                  :class="{
                    'is-invalid':
                      submitOrctoItem && v$.orctoItemData.vlrunitliq.$error,
                  }"
                />
                <div
                  v-if="submitOrctoItem && v$.orctoItemData.vlrunitliq.$error"
                  class="invalid-feedback"
                >
                  <span v-if="v$.orctoItemData.vlrunitliq.required.$message">{{
                    v$.orctoItemData.vlrunitliq.required.$message
                  }}</span>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3">
                <label for="qtd">Quantidade</label>
                <input
                  id="qtd"
                  v-model="orctoItemData.qtd"
                  type="number"
                  class="form-control text-end"
                  placeholder="Quantidade"
                  :class="{
                    'is-invalid':
                      submitOrctoItem && v$.orctoItemData.qtd.$error,
                  }"
                />
                <div
                  v-if="submitOrctoItem && v$.orctoItemData.qtd.$error"
                  class="invalid-feedback"
                >
                  <span v-if="v$.orctoItemData.qtd.required.$message">{{
                    v$.orctoItemData.qtd.required.$message
                  }}</span>
                </div>
              </div>
            </div>

            <div class="col-md-4" v-if="orctoItemData.deflote && empresaData.tipoestoque === 'PADRAO'">
              <div class="mb-3">
                <label for="lote">Lotes</label>
                <multiselect
                  id="lotes"
                  @search-change="pesqLotes"
                  v-model="orctoItemData.lote"
                  placeholder="Selecionar lotes"
                  :options="dtListLotes"
                  :searchable="true"
                  label="lote"
                  track-by="lote"
                  value-prop="lote"
                >
                  <template #option="slotProps">
                    <div class="row">
                      <div class="mt-2 font-size-14">
                        {{ `${slotProps.option.lote}(${slotProps.option.endwms}): ${slotProps.option.saldo}` }}
                      </div>
                      <div class="mt-2 font-size-20">
                      </div>
                    </div>
                  </template>
                </multiselect>
              </div>
            </div>

            <div class="col-md-4" v-if="empresaData.tipoestoque === 'DESCON'">
              <div class="mb-3">
                <label for="lote">Lotes</label>
                  <input
                      id="qtd"
                      v-model="orctoItemData.lote"
                      type="text"
                      class="form-control text-end"
                      placeholder="Lote"
                  />
              </div>
            </div>
          </div>
        </form>

        <div class="row text-end" v-if="messageValidacaoItem !== ''">
          <div class="col-md-12">
            <span class="text-danger"> {{ messageValidacaoItem }} * </span>
          </div>
        </div>

        <div class="row">
          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalOrctoItem = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>
            <b-button
              variant="success"
              class="ms-1"
              @click="confOrctoItem"
              :disabled="messageValidacaoItem !== ''"
            >
              <!--confOrctoItem | orctoitemUpdate-->
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

<!--    Ajuste de condição de pagamento e forma de pagamento em modal dados financeiro

    <b-modal
      title="Detalhes Pagamento"
      v-model="showModalCondPgto"
      centered
      hide-footer
    >
      <div class="col-md-12 mt-2">
        <div class="mb-3">
          <span>Selecionar Nova Forma de Pagamento</span>

          <multiselect
            id="formapgto"
            @search-change="pesqFormaPgto"
            @select="escolheuFormaPgto"
            v-model="orctoData.formapgto"
            placeholder="Pesquisar forma de pagamento"
            :options="dtListPesqFormaPgto"
            :searchable="true"
            label="descricao"
            track-by="descricao"
            value-prop="codigo"
          >
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4"> </span>
                </div>
                <div class="mt-2 font-size-20">
                  {{ slotProps.option.descricao }}
                </div>
                <span class="mx-4"> </span>
                <span class="mx-4"> </span>
                <div class="align-items-end text-end align-content-end">
                  {{ formatDateTime(slotProps.option.created_at) }}
                </div>
              </div>
            </template>
          </multiselect>
        </div>
      </div>

      <div class="col-md-12 mt-2">
        <div class="mb-3">
          <span>Selecionar Nova Condição de Pagamento</span>

          <multiselect
            id="condpgto"
            @search-change="pesqCondPgto"
            @select="escolheuCondPgto"
            v-model="orctoData.condpgto"
            placeholder="Pesquisar condição de pagamento"
            :options="dtListPesqCondPgto"
            :searchable="true"
            label="descricao"
            track-by="descricao"
            value-prop="codigo"
          >
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4"> </span>
                </div>
                <div class="mt-2 font-size-20">
                  {{ slotProps.option.descricao }}
                </div>

                <span class="mx-4"> </span>
                <span class="mx-4"> </span>
                <div class="align-items-end text-end align-content-end">
                  {{ formatDateTime(slotProps.option.created_at) }}
                </div>
              </div>
            </template>
          </multiselect>
        </div>
      </div>

      <div class="row" v-if="loadingCondPgto">
        <div class="col-12 text-center">
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingCondPgto && condPgtoData && formaPgtoData">
        <div class="mt-2">
          <p class="mb-2">Forma de Pagamento Atual</p>

          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ formaPgtoData.codigo }} </span>
          </p>

          <p class="mb-2">
            Descrição:
            <span class="text-primary"> {{ formaPgtoData.descricao }} </span>
          </p>
        </div>

        <div class="mt-4">
          <p class="mb-2">Condição de Pagamento Atual</p>

          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ condPgtoData.codigo }} </span>
          </p>

          <p class="mb-2">
            Descrição:
            <span class="text-primary"> {{ condPgtoData.descricao }} </span>
          </p>
        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalCondPgto = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button
            type="submit"
            variant="success"
            class="ms-1"
            @click="confirmarFormaPgto"
          >
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>-->

    <b-modal
      title="Alterar Data Orçamento"
      v-model="showModalDataOrcamento"
      centered
      hide-footer
    >
      <div class="col-md-12 mt-2">
        <div class="mb-3">
          <!-- <span>Selecionar Nova Data Orçamento</span> -->
          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="novaDtOracamento"
                  >Selecionar Nova Data Orçamento</label
                >
                <input
                  id="novaDtOracamento"
                  v-model="orctoData.dtemissao"
                  type="date"
                  class="form-control"
                  placeholder="Data Orçamento"
                  :class="{ 'is-invalid': submittedPeriodo && !dtIniFiltro }"
                />
                <div
                  v-if="submittedPeriodo && !dtIniFiltro"
                  class="invalid-feedback"
                >
                  <span>Campo data início obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="loadingCondPgto">
        <div class="col-12 text-center">
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
          <b-spinner
            type="grow"
            class="m-6 mx-2"
            variant="secondary"
            role="status"
          >
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingCondPgto && condPgtoData && formaPgtoData">
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalCondPgto = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button
            type="submit"
            variant="success"
            class="ms-1"
            @click="confirmarDataOrcamento"
          >
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      size="xl"
      title="Cotação de Frete"
      v-model="showModalCotarFrete"
      centered
      hide-footer
    >
      <div class="col-md-12">
        <div class="row" v-if="loadingCotarFrete">
          <div class="col-12 text-center">
            <b-spinner
              type="grow"
              class="m-6 mx-2"
              variant="secondary"
              role="status"
            >
            </b-spinner>
            <b-spinner
              type="grow"
              class="m-6 mx-2"
              variant="secondary"
              role="status"
            >
            </b-spinner>
            <b-spinner
              type="grow"
              class="m-6 mx-2"
              variant="secondary"
              role="status"
            >
            </b-spinner>
          </div>
        </div>

        <div class="table-responsive" v-if="cotaFreteListData">
          <table class="table table-centered table-nowrap">
            <thead>
              <tr>
                <th scope="col">Ações</th>
                <th scope="col">TranspNome</th>
                <th scope="col" class="">Frete R$</th>
                <th scope="col" class="">Frete %</th>
                <th scope="col" class="">Frete KG</th>

                <th scope="col" class="text-end">PrazoDias</th>

                <th scope="col">TranspCNPJ</th>
                <th scope="col">TranspEmail</th>
                <th scope="col" class="text-end">Mov.Cot.ID</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="data in cotaFreteListData" :key="data.id">
                <td>
                  <a
                    href="javascript:void(0);"
                    v-b-tooltip.hover
                    class="action-icon text-info mx-2"
                    title="Definir valor orçamento frete"
                    @click="escolherFrete(data.WSOut_MovSim_ID,data.WSOut_Transp_CNPJ, data.WSOut_Frete_Val)"
                  >
                    <i class="mdi mdi-check-outline font-size-18"></i>
                  </a>
                </td>

                <td>
                  {{ data.WSOut_Transp_Nome }}
                </td>

                <td class="text-end">
                  <i
                    class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success"
                    v-if="data.menorvalor"
                  ></i>
                  {{ formatDecimal(data.WSOut_Frete_Val) }}
                </td>

                <td class="text-end">
                  <i
                    class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success"
                    v-if="data.menorvalor"
                  ></i>
                  {{
                    formatDecimal(
                      (data.WSOut_Frete_Val / orctoData.valorliq) * 100
                    )
                  }}
                </td>

                <td class="text-end">
                  <i
                    class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success"
                    v-if="data.menorvalor"
                  ></i>
                  {{
                    formatDecimal((data.WSOut_Frete_Val / orctoData.peso) * 100)
                  }}
                </td>

                <!--              <td>-->
                <!--                <div>-->
                <!--                  <h5 class="text-truncate font-size-14">-->
                <!--                    {{ formatDateTime(data.WSOut_DataH) }}-->
                <!--                  </h5>-->
                <!--                </div>-->
                <!--              </td>-->

                <td class="text-end">
                  <i
                    class="bx bxs-calendar font-size-18 bx-fade-right text-info"
                    v-if="data.menorprazo"
                  ></i>
                  {{ data.WSOut_Prazo_Dias }}
                </td>

                <!--              <td class="text-end">-->
                <!--                {{ data.WSOut_Indic }}-->
                <!--              </td>-->
                <!--              <td class="text-end">-->
                <!--                {{ data.WSOut_MovCot_ID }}-->
                <!--              </td>-->
                <!--              <td class="text-end">-->
                <!--                {{ data.WSOut_MovSim_ID }}-->
                <!--              </td>-->
                <!--              <td>-->
                <!--                {{ data.WSOut_NotaS }}-->
                <!--              </td>-->

                <td>
                  {{ data.WSOut_Transp_CNPJ }}
                </td>
                <td>
                  {{ data.WSOut_Transp_Email }}
                </td>
                <td class="text-end">
                  {{ data.WSOut_MovCot_ID }}
                </td>
              </tr>

              <!--            <tr>-->
              <!--              <td colspan="4">-->
              <!--                <h6 class="m-0 text-end">Quantidade Total Volumes:</h6>-->
              <!--              </td>-->
              <!--              <td class="text-end"> {{ formatDecimal(0.00) }}</td>-->
              <!--            </tr>-->

              <!--            <tr>-->
              <!--              <td colspan="4">-->
              <!--                <h6 class="m-0 font-size-14  text-end">Peso Total Volumes:</h6>-->
              <!--              </td>-->
              <!--              <td class="font-size-14 text-end"> {{ formatDecimal(0.00) }}</td>-->
              <!--            </tr>-->
            </tbody>
          </table>
        </div>

        <!--        <div class="mb-3">-->
        <!--          <label for="obs">Observações do Pedido</label>-->
        <!--          <textarea-->
        <!--              id="obs"-->
        <!--              v-model="orctoData.obs"-->
        <!--              type="text"-->
        <!--              rows="3"-->
        <!--              class="form-control"-->
        <!--              placeholder="Observações do Pedido"/>-->
        <!--        </div>-->

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalCotarFrete = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button
            type="submit"
            variant="success"
            class="ms-1"
            @click="showModalCotarFrete = false"
          >
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      size="lg"
      :title="
        orctoFinanData.id != null
          ? `Editar Pagamento do Orçamento (${orctoFinanData.id})`
          : 'Criar Novo Pagamento no Orçamento'
      "
      v-model="showModalOrctoFinan"
      hide-footer
    >
      <div>
        <form class="needs-validation" @submit.prevent="confOrctoFinanc">
          <div class="row">
            <div class="col-md-6 mt-2">
              <div class="mb-3">
                <span>Forma de Pagamento</span>
                <multiselect
                  id="formapgto"
                  @search-change="pesqFormaPgto"
                  @select="escolheuFormaPgto"
                  v-model="orctoFinanData.formapgto"
                  placeholder="Pesquisar forma de pagamento"
                  :options="dtListPesqFormaPgto"
                  :searchable="true"
                  label="descricao"
                  track-by="descricao"
                  :style="
                    submitOrctoFinanc && !orctoFinanData.formapgto
                      ? 'border: 1px solid #f86c6b !important;'
                      : ''
                  "
                  value-prop="codigo"
                >
                  <template #option="slotProps">
                    <div class="row">
                      <div>
                        <span class="text-info">
                          {{ slotProps.option.codigo }}
                        </span>
                        <span class="mx-4"> </span>
                      </div>
                      <div class="mt-2 font-size-20">
                        {{ slotProps.option.descricao }}
                      </div>
                      <span class="mx-4"></span>
                      <span class="mx-4"></span>
                      <div class="align-items-end text-end align-content-end">
                        {{ formatDateTime(slotProps.option.created_at) }}
                      </div>
                    </div>
                  </template>
                </multiselect>
                <div v-if="submitOrctoFinanc && !orctoFinanData.formapgto">
                  <span class="text-danger font-size-11"
                    >Campo Forma de Pagamento obrigatório, favor
                    preencher.</span
                  >
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3">
                <label for="valor">Valor</label>
                <input
                  id="valor"
                  v-model="orctoFinanData.valor"
                  type="number"
                  class="form-control text-end"
                  placeholder="Valor"
                  :class="{
                    'is-invalid': submitOrctoFinanc && !orctoFinanData.valor,
                  }"
                />
                <div
                  v-if="submitOrctoFinanc && !orctoFinanData.valor"
                  class="invalid-feedback"
                >
                  <span> Campo valor obrigatório, favor preencher. </span>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="mb-3">
              <label for="obs">Observações</label>
              <textarea
                id="obs"
                v-model="orctoFinanData.obs"
                type="text"
                rows="3"
                class="form-control"
                placeholder="Observações"
              />
            </div>
          </div>
        </form>

        <div class="row text-end" v-if="messageValidacaoItem !== ''">
          <div class="col-md-12">
            <span class="text-danger"> {{ messageValidacaoItem }} * </span>
          </div>
        </div>

        <div class="row">
          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalOrctoFinan = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>

            <b-button
              variant="outline-danger"
              class="ms-1"
              @click="excluirFinanc"
              v-if="orctoFinanData.id > 0"
            >
              <i class="bx bx-trash font-size-16 align-middle me-2"></i>
              Excluir Lançamento
            </b-button>

            <b-button
              variant="success"
              class="ms-1"
              @click="confOrctoFinanc"
              :disabled="messageValidacaoItem !== ''"
            >
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      size="md"
      title="Detalhamento de Carga"
      v-model="showModalCarga"
      hide-footer
    >
      <div>
        <form class="needs-validation" @submit.prevent="confCodCarga">
          <div class="row">
            <div class="col-md-12">
              <div class="mb-3">
                <label for="carga">Código de Carga</label>
                <input
                  id="carga"
                  v-model="orctoData.carga"
                  type="text"
                  class="form-control text-end"
                  placeholder="Código de Carga"
                  :class="{ 'is-invalid': submitCodCarga && !orctoData.carga }"
                />
                <div
                  v-if="submitCodCarga && !orctoData.carga"
                  class="invalid-feedback"
                >
                  <span>
                    Campo código de carga obrigatório, favor preencher.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </form>

        <div class="row">
          <div class="row" v-if="loadingCargas">
            <div class="col-12 text-center">
              <b-spinner
                type="grow"
                class="m-6 mx-2"
                variant="secondary"
                role="status"
              >
              </b-spinner>
              <b-spinner
                type="grow"
                class="m-6 mx-2"
                variant="secondary"
                role="status"
              >
              </b-spinner>
              <b-spinner
                type="grow"
                class="m-6 mx-2"
                variant="secondary"
                role="status"
              >
              </b-spinner>
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <span>Todas as Cargas</span>

          <table class="table align-middle mb-0 mt-2 table-nowrap">
            <thead class="table-light">
              <tr>
                <th>Carga</th>
                <th class="text-end">m³</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="data in cargasData" :key="data.carga">
                <td class="text-start">{{ data.carga }}</td>
                <td class="text-end">{{ formatDecimalQuatro(data.cubtot) }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="row">
          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalCarga = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>
            <b-button variant="success" class="ms-1" @click="confCodCarga">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      title="Sugestão de Itens"
      v-model="showModalSugereItens"
      size="xl"
      centered
      hide-footer
    >
      <div class="col-md-12">
        <div class="mb-3">
          <!--          <label for="notatipo">Fornecedor encontrado com este CNPJ</label>-->
          <div class="row">
            <div class="row">
              <div class="col-md-1">
                <div>
                  <label>ID</label>
                </div>
              </div>
              <div class="col-md-1">
                <div>
                  <label>Código</label>
                </div>
              </div>
              <div class="col-md-4">
                <div>
                  <label>Descrição</label>
                </div>
              </div>
              <div class="col-md-1 text-end">
                <div>
                  <label>Quantidade</label>
                </div>
              </div>
              <div class="col-md-2 text-end">
                <div>
                  <label>Valor Unitário</label>
                </div>
              </div>
              <div class="col-md-2 text-end">
                <div>
                  <label>Valor Total</label>
                </div>
              </div>
              <div class="col-md-1 text-end"></div>
            </div>
          </div>

          <div
            v-for="(field, index) in orctoItensSugeridos"
            :key="field.id"
            class="row"
          >
            <div class="col-md-1 text-end">
              <input
                id="sug_produto_id"
                v-model="field.produto_id"
                type="number"
                class="form-control"
                placeholder="ID"
                :disabled="true"
              />
            </div>
            <div class="col-md-1 text-end">
              <input
                id="sug_produto"
                v-model="field.produto"
                type="text"
                class="form-control"
                placeholder="código"
                :disabled="true"
                :class="{
                  'is-invalid': submittedItensSugeridos && !field.produto,
                }"
              />
              <div
                v-if="submittedItensSugeridos && !field.produto"
                class="invalid-feedback"
              >
                <span>Campo código obrigatório, favor preencher.</span>
              </div>
            </div>
            <div class="col-md-4 text-end">
              <input
                id="sug_descricao"
                v-model="field.descprod"
                type="text"
                class="form-control"
                placeholder="Descrição"
                :disabled="true"
                :class="{
                  'is-invalid': submittedItensSugeridos && !field.descricao,
                }"
              />
              <div
                v-if="submittedItensSugeridos && !field.descricao"
                class="invalid-feedback"
              >
                <span>Campo descrição obrigatório, favor preencher.</span>
              </div>
            </div>
            <div class="col-md-1 text-end">
              <input
                :id="`sug_qtd${field.produto_id}`"
                v-model="field.qtd"
                type="number"
                class="form-control text-end"
                placeholder="Quantidade"
                :class="{ 'is-invalid': submittedItensSugeridos && !field.qtd }"
              />
              <div
                v-if="submittedItensSugeridos && !field.qtd"
                class="invalid-feedback"
              >
                <span>Campo quantidade obrigatório, favor preencher.</span>
              </div>
            </div>
            <div class="col-md-2 text-end">
              <input
                id="sug_vlrunit"
                v-model="field.vlrunitliq"
                type="number"
                class="form-control text-end"
                placeholder="Valor Unitário"
                :class="{
                  'is-invalid': submittedItensSugeridos && !field.vlrunit,
                }"
              />
              <div
                v-if="submittedItensSugeridos && !field.vlrunit"
                class="invalid-feedback"
              >
                <span>Campo Valor Unitário obrigatório, favor preencher.</span>
              </div>
            </div>
            <div class="col-md-2 text-end">
              <input
                id="sug_vlrtotal"
                v-model="field.vlrtotalliq"
                type="number"
                class="form-control text-end"
                :disabled="true"
                placeholder="Valor Total"
              />
            </div>
            <div class="col-md-1 text-end">
              <div class="button-items">
                <b-button
                  variant="outline-danger"
                  @click="deletarItemSug(index)"
                >
                  <i class="mdi mdi-trash-can d-block font-size-16"></i>
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalSugereItens = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button
            type="submit"
            variant="success"
            class="ms-1"
            :disabled="
              !orctoItensSugeridos.length || orctoItensSugeridos.length === 0
            "
            @click="confSugestao"
          >
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar Alterações
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      v-model="showErrosLotes"
      id="showErrosLotes"
      size="lg"
      title="Lotes para validação"
      title-class="font-18"
      hide-footer
    >
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>Sequência</th>
                      <th>Código Produto</th>
                      <th>Produto</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="data in listErroLote" :key="data.id">
                      <td>{{ data.sequenc }}</td>
                      <td>{{ data.codprod }}</td>
                      <td>{{ data.descprod }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      v-model="showModalErro"
      id="showModalErro"
      size="lg"
      title="Erro"
      title-class="font-18"
      hide-footer
    >
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div v-if="Array.isArray(errorMessage)">
                <div v-for="data in errorMessage" :key="data.id">
                  <h5>{{data}}</h5>
                  <hr>
                </div>
              </div>

              <div v-else>
                <h5>{{errorMessage}}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      title="Adicionar Logo Campanha"
      v-model="showModalAddCampanha"
      hide-footer
    >
      <div class="row">
        <div class="mb-3">
          <label class="d-flex" for="campanha">
            <i class="bx bx-search-alt-2 me-1 text-end"></i>
            <h5 class="text-muted">Buscar campanhas salvas</h5>
          </label>
          <multiselect
            id="campanha"
            @search-change="pesqCampanha"
            @select="escolheuCampanha"
            v-model="orctoData.codcampanha"
            :value="orctoData.codcampanha"
            placeholder="Selecionar Campanha"
            :options="dtListCampanhas"
            :searchable="true"
            label="Campanhas"
            track-by="codigo"
            value-prop="codigo"
          >
            <template #option="slotProps">
              <div class="row">
                <div class="mt-2 font-size-20">
                  {{
                    `${slotProps.option.codigo} - ${slotProps.option.descricao}`
                  }}
                </div>
              </div>
            </template>
          </multiselect>
        </div>
      </div>

      <div class="row">
        <div class="card-body">
          <h4 class="card-title">Selecionar novo arquivo</h4>
          <DropZone @change="selectedFile" />
          <span class="file-info mt-1">Arquivo: {{ dropzoneFile.name }}</span>
          <hr />
          <div class="d-flex mt-2">
            <div class="col-md-4 me-2">
              <label for="codcamp">Código Campanha</label>
              <input
                id="codcamp"
                v-model="campanhaData.codigo"
                type="text"
                class="form-control text-start"
                placeholder="Código Campanha"
              />
            </div>

            <div class="col-md-8 me-2">
              <label for="desccamp">Descrição/Nome</label>
              <input
                id="desccamp"
                v-model="campanhaData.descricao"
                type="text"
                class="form-control text-start"
                placeholder="Descrição/Nome"
              />
            </div>
          </div>

          <div v-if="submittedAnexo && !dropzoneFile.name">
            <span class="text-danger font-size-11"
              >Favor selecionar o arquivo e tentar novamente.</span
            >
          </div>
        </div>
      </div>

      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalAddCampanha = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button
          type="submit"
          variant="success"
          class="ms-1"
          @click="validaImportacaoCampanha"
        >
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>

    <!--showModalIndicaPedido-->
    <b-modal title="Agregar Orçamento à pedido" v-model="showModalIndicaPedido" hide-footer>
      <div class="row">
        <div class="mb-3">
          <label class="d-flex" for="pedido">
            <i class="bx bx-search-alt-2  me-1 text-end"></i>
            <h5 class=text-muted>Buscar Pedidos</h5>
          </label>
          <multiselect id="pedido"
                        @search-change="pesqPedido"
                        @select="escolheuPedido"
                        v-model="orctoData.agregped_id"
                        :value="orctoData.agregped_id"
                        placeholder="Selecionar Pedido"
                        :options="dtListPedidos"
                        :searchable="true"
                        label="Pedidos"
                        track-by="id"
                        value-prop="id">
            <template #option="slotProps">
              <div class="row">
                <div class="mt-2 font-size-20">{{ `Cód.(${slotProps.option.id}) - ID(${slotProps.option.codigo}) (${formatDate(slotProps.option.created_at)})` }}</div>
              </div>
            </template>
          </multiselect>
        </div>
      </div>

      <!--<div class="text-end mt-5">
        <b-button variant="light" @click="showModalIndicaPedido = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="validaImportacaoCampanha">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>-->
    </b-modal>

    <b-modal
        v-model="showModalAssociaLotes"
        id="showModalAssociaLotes"
        size="xl"
        title="Associação de lotes"
        title-class="font-18"
        hide-footer
    >
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                  <tr>
                    <th>Produto</th>
                    <th>Código</th>
                    <th>ID</th>
                    <th>Qtd.</th>
                    <th>Lote</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="data in dtListAssociaLote" :key="data.id">
                    <td class="text-start">{{data.descprod}}</td>
                    <td class="text-start">{{data.produto}}</td>
                    <td class="text-center">{{data.produto_id}}</td>
                    <td class="text-center">{{formatDecimal(data.qtd)}}</td>
                    <td class="text-center" style="width: 200px">
                      <multiselect
                          id="lotes"
                          v-model="data.lote"
                          :mode="'tags'"
                          :options="data.optionsLotes"
                          placeholder="Selecionar lotes"
                          label="cod"
                          track-by="cod"
                          value-prop="cod"
                      >
                        <template #option="slotProps">
                          <div class="row">
                            <div class="mt-2 font-size-16">
                              <span class="text-info">
                                {{ slotProps.option.cod }}
                              </span>
                              <span class="ms-2">
                                {{ `(Qtd: ${slotProps.option.saldo})` }}
                              </span>
                            </div>
                          </div>
                        </template>
                      </multiselect>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div v-if="updatingReserva">
            <h3 class="text-info text-center">Aguarde um momento, estamos reservando os saldos dos produtos...</h3>
          </div>

          <div class="row" v-if="updatingReserva">
            <div class="col-12 text-center">
              <b-spinner type="grow"
                         class="m-6 mx-2"
                         variant="secondary"
                         role="status">
              </b-spinner>
              <b-spinner type="grow"
                         class="m-6 mx-2"
                         variant="secondary"
                         role="status">
              </b-spinner>
              <b-spinner type="grow"
                         class="m-6 mx-2"
                         variant="secondary"
                         role="status">
              </b-spinner>
            </div>
          </div>

          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalAssociaLotes = false" :disabled="updatingReserva">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>

            <b-button
                type="submit"
                variant="success"
                class="ms-1"
                @click="gerarReservaSaldos"
                :disabled="updatingReserva"
            >
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
        v-model="showModalMsgUpdating"
        id="showModalMsgUpdating"
        size="lg"
        hide-footer
    >
      <div>
        <h3 class="text-info text-center">Aguarde um momento, estamos processando os dados...</h3>
      </div>

      <div class="row">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>
    </b-modal>

  </Layout>
</template>

<style>
.multiselect-size {
  --ms-max-height: 500px;
}
</style>
